export const footerMock = {
  id: 119,
  slug: 'footer-original',
  createdAt: '2025-12-30T10:20:50.013Z',
  updatedAt: '2026-03-19T06:47:05.247Z',
  publishedAt: '2026-03-19T06:47:05.900Z',
  locale: 'en',
  documentId: 'kvslnpjh944qpn69b2jrbkzo',
  footer: {
    id: 116,
    logo: {
      id: 301106,
      isExpandable: null,
      altText: null,
      image: {
        url: '/images/visual-test-icon.svg',
        alternativeText: 'Decodo Logo',
        width: 125,
        height: 20,
        caption: 'Decodo Logo',
      },
    },
    contacts: [
      {
        id: 257,
        title: 'GET IN TOUCH',
        links: [
          {
            id: 2507,
            image: {
              id: 301107,
              isExpandable: null,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 27,
                height: 26,
                caption: null,
              },
            },
            link: {
              id: 122859,
              text: null,
              url: 'https://direct.lc.chat/12092754',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            popup: null,
          },
          {
            id: 2508,
            image: {
              id: 301108,
              isExpandable: null,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 26,
                height: 26,
                caption: null,
              },
            },
            link: {
              id: 122860,
              text: null,
              url: 'mailto:sales@decodo.com',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            popup: null,
          },
          {
            id: 2513,
            image: {
              id: 301109,
              isExpandable: null,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 96,
                height: 96,
                caption: null,
              },
            },
            link: null,
            popup: {
              id: 301115,
              isExpandable: false,
              altText: null,
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 360,
                height: 360,
                caption: null,
              },
            },
          },
          {
            id: 2514,
            image: {
              id: 301110,
              isExpandable: null,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 24,
                height: 24,
                caption: null,
              },
            },
            link: {
              id: 122861,
              text: null,
              url: 'https://t.me/decodo_com',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            popup: {
              id: 301116,
              isExpandable: null,
              altText: null,
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 715,
                height: 682,
                caption: null,
              },
            },
          },
        ],
      },
      {
        id: 256,
        title: 'FOLLOW US',
        links: [
          {
            id: 2509,
            image: {
              id: 301111,
              isExpandable: null,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 19,
                height: 19,
                caption: null,
              },
            },
            link: {
              id: 122862,
              text: null,
              url: 'https://www.youtube.com/channel/UCqHoe4Ixju1bcOy0jHPO8Kg',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            popup: null,
          },
          {
            id: 2510,
            image: {
              id: 301112,
              isExpandable: null,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 20,
                height: 19,
                caption: null,
              },
            },
            link: {
              id: 122863,
              text: null,
              url: 'https://github.com/Decodo',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            popup: null,
          },
          {
            id: 2511,
            image: {
              id: 301113,
              isExpandable: null,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 20,
                height: 19,
                caption: null,
              },
            },
            link: {
              id: 122864,
              text: null,
              url: 'https://www.linkedin.com/company/decodo/',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            popup: null,
          },
          {
            id: 2512,
            image: {
              id: 301114,
              isExpandable: null,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 24,
                height: 24,
                caption: null,
              },
            },
            link: {
              id: 122865,
              text: null,
              url: 'https://discord.gg/WQHGnpgJfC',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            popup: null,
          },
        ],
      },
    ],
    categories: [
      {
        id: 449,
        title: 'COMPANY',
        links: [
          {
            id: 122866,
            text: 'About us',
            url: '/about',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122867,
            text: 'Careers',
            url: '/careers',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122868,
            text: 'Community',
            url: 'https://discord.com/invite/gvJhWJPaB4',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122869,
            text: 'Security & compliance',
            url: 'https://decodo.com/security-compliance',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122870,
            text: 'Privacy policy',
            url: '/legal',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122871,
            text: 'License agreement',
            url: '/legal/license-agreement',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122872,
            text: 'Ethical sourcing & usage',
            url: '/proxies/ethical-residential-proxy-sourcing-and-usage',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122873,
            text: 'AI Chatbot Privacy Notice',
            url: '/legal/ai-chatbot-privacy-notice',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122874,
            text: 'Smartproxy',
            url: 'https://decodo.com/smartproxy',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
        ],
      },
      {
        id: 450,
        title: 'PRODUCTS',
        links: [
          {
            id: 122875,
            text: 'Proxy servers',
            url: '/proxies/buy',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122876,
            text: 'Residential proxies',
            url: '/proxies/residential-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122877,
            text: 'ISP proxies',
            url: '/proxies/isp-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122878,
            text: 'Mobile proxies',
            url: '/proxies/mobile',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122879,
            text: 'Datacenter proxies',
            url: '/proxies/datacenter-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122880,
            text: 'Web Scraping API',
            url: '/scraping/web',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122881,
            text: 'eCommerce Scraping API',
            url: '/scraping/ecommerce',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122882,
            text: 'SERP Scraping API',
            url: '/scraping/serp',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122883,
            text: 'Social Media Scraping API',
            url: '/scraping/social-media',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
        ],
      },
      {
        id: 451,
        title: 'RESOURCES',
        links: [
          {
            id: 122884,
            text: 'FAQ',
            url: '/faq',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122885,
            text: 'Billing',
            url: '/faq/billing',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122886,
            text: 'Getting started',
            url: '/faq/getting-started',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122887,
            text: 'Documentation',
            url: 'https://help.decodo.com/docs/introduction',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122888,
            text: 'Blog',
            url: '/blog',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122889,
            text: 'Glossary',
            url: '/glossary',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122890,
            text: 'Best hub',
            url: '/best',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122891,
            text: 'Affiliate program',
            url: '/proxy-affiliate-program',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122892,
            text: 'Referral program',
            url: '/deals/referral-program',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122893,
            text: 'AI newsletter',
            url: '/ai-newsletter',
            openInNewTab: false,
            variant: null,
            color: 'primary',
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
        ],
      },
      {
        id: 452,
        title: 'PROXY FEATURES',
        links: [
          {
            id: 122894,
            text: 'Static residential proxies',
            url: '/proxies/static-residential-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122895,
            text: 'SOCKS5 proxies',
            url: '/proxies/socks5',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122896,
            text: 'Unlimited proxies',
            url: '/proxies/unlimited-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122897,
            text: 'Rotating proxies',
            url: '/proxies/rotating-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122898,
            text: 'Dedicated proxies',
            url: '/proxies/dedicated-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122899,
            text: 'Shared proxies',
            url: '/proxies/shared-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122900,
            text: 'UDP proxies',
            url: '/proxies/udp-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122901,
            text: 'Sticky residential proxies',
            url: '/proxies/sticky-residential-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
        ],
      },
      {
        id: 453,
        title: 'PROXY TARGETS',
        links: [
          {
            id: 122902,
            text: 'YouTube proxies',
            url: '/proxies/youtube-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122903,
            text: 'Reddit proxies',
            url: '/proxies/reddit-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122904,
            text: 'eBay proxies',
            url: '/proxies/ebay-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122905,
            text: 'Craigslist proxies',
            url: '/proxies/craigslist-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122906,
            text: 'Pinterest proxies',
            url: '/proxies/pinterest-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122907,
            text: 'Shopify proxies',
            url: '/proxies/shopify-proxies',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
        ],
      },
      {
        id: 454,
        title: 'SCRAPING TARGETS',
        links: [
          {
            id: 122908,
            text: 'ZoomInfo Scraper',
            url: '/scraping/web/zoominfo',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122909,
            text: 'Airbnb Scraper',
            url: '/scraping/web/airbnb',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122910,
            text: 'Justdial Scraper',
            url: '/scraping/web/justdial',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122911,
            text: 'Indeed Scraper',
            url: '/scraping/web/indeed',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122912,
            text: 'Google Hotel Scraper',
            url: '/scraping/serp/google-hotel',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122913,
            text: 'Google Autocomplete Scraper',
            url: '/scraping/serp/google-autocomplete-api',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122914,
            text: 'Redfin Scraper',
            url: '/scraping/web/redfin',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
          {
            id: 122915,
            text: 'Amazon ASIN Scraper',
            url: '/scraping/ecommerce/amazon/asin',
            openInNewTab: false,
            variant: null,
            color: null,
            rel: null,
            phTracker: null,
            leftSection: null,
            rightSection: null,
          },
        ],
      },
    ],
  },
  blog_footer_reference: [
    {
      id: 480,
      slug: 'ethical-web-data-collection-initiative',
      createdAt: '2024-07-03T07:33:19.012Z',
      updatedAt: '2024-09-05T11:07:47.310Z',
      publishedAt: '2024-07-03T07:33:18.628Z',
      locale: 'en',
      documentId: 'euwyh14kma57jgksos79c62j',
    },
    {
      id: 2300,
      slug: 'instagram-feedback-required',
      createdAt: '2024-07-03T07:33:22.995Z',
      updatedAt: '2025-04-15T11:11:53.035Z',
      publishedAt: '2025-04-15T11:11:53.735Z',
      locale: 'en',
      documentId: 'c2w5pbwolcibutuqhe1zyht2',
    },
    {
      id: 4125,
      slug: 'what-is-parsing',
      createdAt: '2024-07-03T07:33:32.520Z',
      updatedAt: '2026-05-21T13:46:50.779Z',
      publishedAt: '2026-05-21T13:46:52.141Z',
      locale: 'en',
      documentId: 'c6tm5oy0msjdxnyhr00b68gj',
    },
    {
      id: 3482,
      slug: 'instagram-action-block',
      createdAt: '2024-07-03T07:33:40.746Z',
      updatedAt: '2026-02-20T13:38:33.497Z',
      publishedAt: '2026-02-20T13:38:34.217Z',
      locale: 'en',
      documentId: 'idk4qlez78zo5d35jj2dvdhc',
    },
    {
      id: 4242,
      slug: 'node-unblocker',
      createdAt: '2024-07-03T07:34:11.058Z',
      updatedAt: '2026-06-08T13:09:22.323Z',
      publishedAt: '2026-06-08T13:09:31.143Z',
      locale: 'en',
      documentId: 'w46vypwumvwdbjfuv5nrrd90',
    },
    {
      id: 3383,
      slug: 'web-scraping-excel-vba',
      createdAt: '2024-07-03T07:34:19.956Z',
      updatedAt: '2026-01-30T13:03:55.461Z',
      publishedAt: '2026-01-30T13:03:57.448Z',
      locale: 'en',
      documentId: 'o1gb1obn5b2lj792vx8fvfq2',
    },
    {
      id: 3385,
      slug: 'how-to-scrape-github',
      createdAt: '2024-07-03T07:34:25.797Z',
      updatedAt: '2026-01-30T13:06:41.158Z',
      publishedAt: '2026-01-30T13:06:43.204Z',
      locale: 'en',
      documentId: 'gsxdkesm7aam22c0i19t9j7n',
    },
    {
      id: 3933,
      slug: 'ad-verification-best-practices',
      createdAt: '2024-07-03T07:34:29.006Z',
      updatedAt: '2026-04-30T11:07:18.698Z',
      publishedAt: '2026-04-30T11:07:19.596Z',
      locale: 'en',
      documentId: 'cq3qvbohaau1qnv2sv5wuidn',
    },
    {
      id: 3330,
      slug: 'how-to-scrape-discogs-marketplace',
      createdAt: '2024-07-03T07:34:44.361Z',
      updatedAt: '2026-01-27T12:57:54.018Z',
      publishedAt: '2026-01-27T12:57:55.772Z',
      locale: 'en',
      documentId: 'jfi6olpfy9c9gtwmlxch1pia',
    },
    {
      id: 4315,
      slug: 'how-residential-proxies-work',
      createdAt: '2024-07-03T07:34:50.872Z',
      updatedAt: '2026-06-11T07:04:32.040Z',
      publishedAt: '2026-06-11T07:04:33.261Z',
      locale: 'en',
      documentId: 'ecde0np9wr0k5kjvlmjjpy9q',
    },
    {
      id: 4295,
      slug: 'how-to-pick-the-best-ser-proxies',
      createdAt: '2024-07-03T07:34:59.478Z',
      updatedAt: '2026-06-10T11:19:08.318Z',
      publishedAt: '2026-06-10T11:19:09.102Z',
      locale: 'en',
      documentId: 'cw5zowemo8lv89s87hh8rj83',
    },
    {
      id: 2060,
      slug: 'using-proxies-and-scraping-solutions',
      createdAt: '2024-07-03T07:35:15.874Z',
      updatedAt: '2025-03-14T12:40:09.909Z',
      publishedAt: '2025-03-14T12:40:11.056Z',
      locale: 'en',
      documentId: 'yd3mv94x7tno7nblwxvnit2j',
    },
    {
      id: 3147,
      slug: 'how-to-web-scrape-dynamic-content',
      createdAt: '2024-07-03T07:35:30.946Z',
      updatedAt: '2025-12-16T12:34:57.952Z',
      publishedAt: '2025-12-16T12:34:58.686Z',
      locale: 'en',
      documentId: 'uk2n5r5evxm95q35ydabqakf',
    },
    {
      id: 4376,
      slug: 'web-scraping-selenium-python',
      createdAt: '2024-07-03T07:35:35.856Z',
      updatedAt: '2026-06-16T12:47:06.819Z',
      publishedAt: '2026-06-16T12:47:08.375Z',
      locale: 'en',
      documentId: 'z7j82m2fq15u5bi9iuvre8cn',
    },
    {
      id: 2302,
      slug: 'facebook-session-expired',
      createdAt: '2024-07-03T07:35:44.417Z',
      updatedAt: '2025-04-15T12:45:15.426Z',
      publishedAt: '2025-04-15T12:45:16.037Z',
      locale: 'en',
      documentId: 'zb8pms5x6u5j78e7270a7vx6',
    },
    {
      id: 3410,
      slug: 'what-is-a-backconnect-proxy',
      createdAt: '2024-07-03T07:35:51.303Z',
      updatedAt: '2026-02-04T06:48:34.816Z',
      publishedAt: '2026-02-04T06:48:36.255Z',
      locale: 'en',
      documentId: 'c4cy7cok4n30p50ikglk1mst',
    },
    {
      id: 4155,
      slug: 'instagram-ip-ban',
      createdAt: '2024-07-03T07:35:57.372Z',
      updatedAt: '2026-05-26T09:51:05.138Z',
      publishedAt: '2026-05-26T09:51:06.550Z',
      locale: 'en',
      documentId: 'tloq4m2cqo5c328gd53cinvz',
    },
    {
      id: 3203,
      slug: 'the-best-instagram-bot',
      createdAt: '2024-07-03T07:36:05.430Z',
      updatedAt: '2025-12-29T10:34:17.966Z',
      publishedAt: '2025-12-29T10:34:18.825Z',
      locale: 'en',
      documentId: 'k72usy2k0bfcg336wdmoo0ul',
    },
    {
      id: 4381,
      slug: 'onlyfans-scraping-guide',
      createdAt: '2024-07-03T07:36:09.738Z',
      updatedAt: '2026-06-16T13:13:18.976Z',
      publishedAt: '2026-06-16T13:13:19.806Z',
      locale: 'en',
      documentId: 'l6okyatiecyz1zj75xyx1mq9',
    },
    {
      id: 3866,
      slug: 'what-is-ssl-proxy',
      createdAt: '2024-07-03T07:36:13.810Z',
      updatedAt: '2026-04-21T12:56:58.611Z',
      publishedAt: '2026-04-21T12:56:59.611Z',
      locale: 'en',
      documentId: 'rz0lvlqywln34yee6wicttu5',
    },
    {
      id: 4157,
      slug: 'how-to-buy-instagram-accounts-safely',
      createdAt: '2024-07-03T07:36:19.433Z',
      updatedAt: '2026-05-26T09:55:27.302Z',
      publishedAt: '2026-05-26T09:55:28.169Z',
      locale: 'en',
      documentId: 'nix2x7o8d97fbkvlxo2jls8b',
    },
    {
      id: 3831,
      slug: 'what-is-a-headless-browser',
      createdAt: '2024-07-03T07:36:24.940Z',
      updatedAt: '2026-04-16T11:51:24.269Z',
      publishedAt: '2026-04-16T11:51:25.098Z',
      locale: 'en',
      documentId: 'n0az9f3e96zcwv7nu8miim6q',
    },
    {
      id: 4332,
      slug: 'what-is-curl',
      createdAt: '2024-07-03T07:36:53.690Z',
      updatedAt: '2026-06-11T11:34:55.900Z',
      publishedAt: '2026-06-11T11:34:57.924Z',
      locale: 'en',
      documentId: 'onb5o2k2w1w85nkpxwxouv4c',
    },
    {
      id: 3696,
      slug: 'how-to-scrape-google-search-results',
      createdAt: '2024-07-03T07:37:05.772Z',
      updatedAt: '2026-03-30T13:04:53.898Z',
      publishedAt: '2026-03-30T13:04:55.240Z',
      locale: 'en',
      documentId: 'j0py6pvegtgtsenh47otbhgh',
    },
    {
      id: 3968,
      slug: 'curl-post-request',
      createdAt: '2024-07-03T07:37:17.574Z',
      updatedAt: '2026-04-30T12:03:58.948Z',
      publishedAt: '2026-04-30T12:04:01.303Z',
      locale: 'en',
      documentId: 'z7x4cbj0l46abc8zpucgndci',
    },
    {
      id: 1778,
      slug: 'nike-shoe-bot-review',
      createdAt: '2024-07-03T07:37:30.562Z',
      updatedAt: '2025-02-07T14:37:19.746Z',
      publishedAt: '2025-02-07T14:37:20.551Z',
      locale: 'en',
      documentId: 'uteoz4ei08b9bkxj9gzc0oy1',
    },
    {
      id: 2121,
      slug: 'beautiful-soup-parsing-tutorial',
      createdAt: '2024-07-03T07:37:36.767Z',
      updatedAt: '2025-03-20T12:38:42.200Z',
      publishedAt: '2025-03-20T12:38:43.273Z',
      locale: 'en',
      documentId: 'hlyc79gknflvqnfwxpwsfmdh',
    },
    {
      id: 2625,
      slug: 'scraping-amazon-product-data',
      createdAt: '2024-07-03T07:37:43.275Z',
      updatedAt: '2025-06-26T10:50:57.719Z',
      publishedAt: '2025-06-26T10:50:59.144Z',
      locale: 'en',
      documentId: 'i4tj6vp8kttqv9cb3h7j3flz',
    },
    {
      id: 3073,
      slug: 'python-errors-and-exceptions',
      createdAt: '2024-07-03T07:37:50.448Z',
      updatedAt: '2025-11-21T09:00:48.353Z',
      publishedAt: '2025-11-21T09:00:49.984Z',
      locale: 'en',
      documentId: 'tjp4k1rrvqrrlsdzqipv19aq',
    },
    {
      id: 3871,
      slug: 'why-rotating-proxies-are-the-best',
      createdAt: '2024-07-03T07:37:55.991Z',
      updatedAt: '2026-04-21T13:17:17.095Z',
      publishedAt: '2026-04-21T13:17:18.614Z',
      locale: 'en',
      documentId: 'gyadv2c0ah1mzswdxg2i1090',
    },
    {
      id: 3692,
      slug: 'web-scraping-google-sheets',
      createdAt: '2024-07-03T07:38:07.527Z',
      updatedAt: '2026-03-30T11:11:47.176Z',
      publishedAt: '2026-03-30T11:11:49.569Z',
      locale: 'en',
      documentId: 'vikw4q68w3uyqk468gb7eus4',
    },
    {
      id: 3072,
      slug: 'mastering-python-requests',
      createdAt: '2024-07-03T07:38:12.608Z',
      updatedAt: '2025-11-21T08:58:12.344Z',
      publishedAt: '2025-11-21T08:58:13.256Z',
      locale: 'en',
      documentId: 'tjz20scoqdppfe750wwklwko',
    },
    {
      id: 3514,
      slug: 'parse-xml-python',
      createdAt: '2024-07-03T07:38:18.672Z',
      updatedAt: '2026-02-25T12:34:13.747Z',
      publishedAt: '2026-02-25T12:34:15.247Z',
      locale: 'en',
      documentId: 'ntqyb2y9to3ygy0uaih8gwia',
    },
    {
      id: 4236,
      slug: 'what-is-the-difference-between-proxy-servers-and-data-centers',
      createdAt: '2024-07-03T07:38:21.645Z',
      updatedAt: '2026-06-05T12:43:57.657Z',
      publishedAt: '2026-06-05T12:43:59.648Z',
      locale: 'en',
      documentId: 'gt21xy5agv49sz15a9xntbw4',
    },
    {
      id: 3967,
      slug: 'curl-get-request',
      createdAt: '2024-07-03T07:38:26.622Z',
      updatedAt: '2026-04-30T12:01:36.397Z',
      publishedAt: '2026-04-30T12:01:38.760Z',
      locale: 'en',
      documentId: 've6emuo20stlbw34u9xbyxr0',
    },
    {
      id: 3841,
      slug: 'what-is-a-sneaker-bot',
      createdAt: '2024-07-03T07:38:40.225Z',
      updatedAt: '2026-04-17T06:35:13.024Z',
      publishedAt: '2026-04-17T06:35:14.048Z',
      locale: 'en',
      documentId: 'ncrwxz03odn6js8skdzftgiu',
    },
    {
      id: 3355,
      slug: 'seo-proxies-when-you-are-serious-about-your-search-ranking',
      createdAt: '2024-07-03T07:38:45.715Z',
      updatedAt: '2026-01-30T09:09:33.304Z',
      publishedAt: '2026-01-30T09:09:34.879Z',
      locale: 'en',
      documentId: 'dncqmdzyaje5ddeqkv3412g2',
    },
    {
      id: 3960,
      slug: 'chatgpt-web-scraping',
      createdAt: '2024-07-03T07:38:52.021Z',
      updatedAt: '2026-04-30T11:44:47.237Z',
      publishedAt: '2026-04-30T11:44:48.471Z',
      locale: 'en',
      documentId: 'oo9uexms65eoq4e38eisylq8',
    },
    {
      id: 3339,
      slug: 'puppeteer-bypass-captcha',
      createdAt: '2024-07-03T07:38:57.474Z',
      updatedAt: '2026-01-27T12:59:11.666Z',
      publishedAt: '2026-01-27T12:59:13.434Z',
      locale: 'en',
      documentId: 'bdyvvkx50q2j98ingh0p9lqw',
    },
    {
      id: 4124,
      slug: 'gathering-amazon-data-best-tools-and-practices',
      createdAt: '2024-07-03T07:39:36.413Z',
      updatedAt: '2026-05-21T07:49:59.195Z',
      publishedAt: '2026-05-21T07:50:00.081Z',
      locale: 'en',
      documentId: 'z704wwcfjb3y630xu913z5no',
    },
    {
      id: 2506,
      slug: 'year-in-review-2023',
      createdAt: '2024-07-03T07:40:26.030Z',
      updatedAt: '2025-06-05T10:55:11.474Z',
      publishedAt: '2025-06-05T10:55:12.285Z',
      locale: 'en',
      documentId: 'ys6u4exhkxyuhv7davrvayn1',
    },
    {
      id: 3485,
      slug: 'instagram-challenge-required',
      createdAt: '2024-07-03T07:40:31.413Z',
      updatedAt: '2026-02-20T13:48:13.800Z',
      publishedAt: '2026-02-20T13:48:14.691Z',
      locale: 'en',
      documentId: 'bwtc6prai0u737yn7fb4ot9z',
    },
    {
      id: 4098,
      slug: 'how-to-bypass-captchas-the-ultimate-guide',
      createdAt: '2024-07-03T07:40:40.785Z',
      updatedAt: '2026-05-18T10:22:23.543Z',
      publishedAt: '2026-05-18T10:22:24.615Z',
      locale: 'en',
      documentId: 'vg1gpgqpvzlvyd51n75jqnvw',
    },
    {
      id: 4312,
      slug: 'ecommerce-trends-and-customer-insights',
      createdAt: '2024-07-03T07:41:12.119Z',
      updatedAt: '2026-06-10T13:48:58.292Z',
      publishedAt: '2026-06-10T13:48:59.468Z',
      locale: 'en',
      documentId: 'u9w2td6hxbeim9o6lkrn5spg',
    },
    {
      id: 3944,
      slug: 'alternative-google-serp-scraping-techniques-terminal-and-curl',
      createdAt: '2024-07-03T07:41:53.725Z',
      updatedAt: '2026-04-30T11:24:19.684Z',
      publishedAt: '2026-04-30T11:24:21.280Z',
      locale: 'en',
      documentId: 'o2sp1po7rb4ykgbbkhy8557o',
    },
    {
      id: 3948,
      slug: 'anti-scraping',
      createdAt: '2024-07-03T07:42:09.462Z',
      updatedAt: '2026-04-30T11:30:34.862Z',
      publishedAt: '2026-04-30T11:30:36.991Z',
      locale: 'en',
      documentId: 'r5hy7ci9iz4ans7vmhq2ffrv',
    },
    {
      id: 587,
      slug: 'how-to-choose-the-best-parser',
      createdAt: '2024-07-03T07:42:20.660Z',
      updatedAt: '2024-11-05T09:31:15.353Z',
      publishedAt: '2024-07-03T07:42:19.856Z',
      locale: 'en',
      documentId: 'bbrp2mgze33aikontl9d7d2s',
    },
    {
      id: 3838,
      slug: 'python-tutorial-how-to-scrape-images-from-websites',
      createdAt: '2024-07-03T07:42:27.603Z',
      updatedAt: '2026-04-17T06:05:12.896Z',
      publishedAt: '2026-04-17T06:05:14.110Z',
      locale: 'en',
      documentId: 'kqu8d8lv4cf7g17suypkgbmk',
    },
    {
      id: 3088,
      slug: 'how-to-scrape-instagram-profiles',
      createdAt: '2024-07-03T07:42:38.582Z',
      updatedAt: '2025-12-04T10:56:34.890Z',
      publishedAt: '2025-12-04T10:56:35.503Z',
      locale: 'en',
      documentId: 'iqtvrkmh1wwl3k3ghrhhgfar',
    },
    {
      id: 3162,
      slug: 'introducing-static-isp-residential-proxies',
      createdAt: '2024-07-03T07:42:44.658Z',
      updatedAt: '2025-12-22T12:08:47.863Z',
      publishedAt: '2025-12-22T12:08:48.324Z',
      locale: 'en',
      documentId: 'tperv2ihcybcnuvzrs1ut2xp',
    },
    {
      id: 595,
      slug: 'decodo-webinar-web-scraping-how-to-successfully-collect-public-data-in-2023',
      createdAt: '2024-07-03T07:42:49.439Z',
      updatedAt: '2024-08-09T08:49:48.943Z',
      publishedAt: '2024-07-03T07:42:48.929Z',
      locale: 'en',
      documentId: 'o6whhp2kkqgltho97yjenf51',
    },
    {
      id: 3305,
      slug: 'scraping-google-without-blocks',
      createdAt: '2024-07-03T07:42:55.367Z',
      updatedAt: '2026-01-19T12:18:49.713Z',
      publishedAt: '2026-01-19T12:18:50.460Z',
      locale: 'en',
      documentId: 'e4tk9u3feg8mpyj855u1gmr5',
    },
    {
      id: 3970,
      slug: 'decodo-cofounds-ewdci',
      createdAt: '2024-07-03T07:43:00.897Z',
      updatedAt: '2026-04-30T12:09:57.651Z',
      publishedAt: '2026-04-30T12:09:58.263Z',
      locale: 'en',
      documentId: 'hhj5z2bzi85wziepgyl4rw5v',
    },
    {
      id: 600,
      slug: 'decodo-acquired',
      createdAt: '2024-07-03T07:43:04.059Z',
      updatedAt: '2024-07-16T14:04:32.466Z',
      publishedAt: '2024-07-03T07:43:03.852Z',
      locale: 'en',
      documentId: 'dmh27rcb82p7sot1ez8oh06y',
    },
    {
      id: 2462,
      slug: 'proxy-error-codes',
      createdAt: '2024-07-03T07:43:14.166Z',
      updatedAt: '2025-05-30T11:39:48.253Z',
      publishedAt: '2025-05-30T11:39:50.321Z',
      locale: 'en',
      documentId: 'gl778evl2a4fqd28vnjxkzlm',
    },
    {
      id: 604,
      slug: 'introducing-the-ewdci-certified-designation',
      createdAt: '2024-07-03T07:43:19.937Z',
      updatedAt: '2024-08-23T09:33:48.003Z',
      publishedAt: '2024-07-03T07:43:19.738Z',
      locale: 'en',
      documentId: 'vl6cahm96svb7m5wgqcxfrz7',
    },
    {
      id: 2693,
      slug: 'social-media-scraping-api',
      createdAt: '2024-07-03T07:43:22.892Z',
      updatedAt: '2025-07-29T07:37:38.851Z',
      publishedAt: '2025-07-29T07:37:39.306Z',
      locale: 'en',
      documentId: 'vjude33xkw2dk896zkkgq2l9',
    },
    {
      id: 3169,
      slug: 'we-released-site-unblocker',
      createdAt: '2024-07-03T07:43:31.021Z',
      updatedAt: '2025-12-22T13:13:40.226Z',
      publishedAt: '2025-12-22T13:13:40.906Z',
      locale: 'en',
      documentId: 'lnzvzprbqvh9mzgpypfvcxb3',
    },
    {
      id: 2191,
      slug: 'web-scraping-efficiently-webinar',
      createdAt: '2024-07-03T07:43:37.419Z',
      updatedAt: '2025-04-04T13:11:14.695Z',
      publishedAt: '2025-04-04T13:11:15.471Z',
      locale: 'en',
      documentId: 'fpr3twvynhc7h4tws5e1kugn',
    },
    {
      id: 3623,
      slug: 'introducing-webhooks',
      createdAt: '2024-07-03T07:43:40.216Z',
      updatedAt: '2026-03-20T12:44:13.308Z',
      publishedAt: '2026-03-20T12:44:14.294Z',
      locale: 'en',
      documentId: 'igq45dbb3shr3qnx53ayr8b1',
    },
    {
      id: 3298,
      slug: 'serp-analysis',
      createdAt: '2024-07-03T07:43:43.680Z',
      updatedAt: '2026-01-19T09:24:31.386Z',
      publishedAt: '2026-01-19T09:24:32.269Z',
      locale: 'en',
      documentId: 'xwb6aq947q2o8l77ew9jcbs3',
    },
    {
      id: 2062,
      slug: 'is-it-legal-to-scrape-amazon',
      createdAt: '2024-07-03T07:44:07.173Z',
      updatedAt: '2025-03-14T12:41:50.528Z',
      publishedAt: '2025-03-14T12:41:51.249Z',
      locale: 'en',
      documentId: 'h7h5j6zs4zyp5t2dzinujjpk',
    },
    {
      id: 1396,
      slug: 'how-to-run-unlimited-sneaker-bot-tasks-with-decodo',
      createdAt: '2024-07-03T07:44:09.066Z',
      updatedAt: '2024-12-06T13:35:00.840Z',
      publishedAt: '2024-12-06T13:35:01.298Z',
      locale: 'en',
      documentId: 'ctblnkb6t0dtjy5sbpw8skbj',
    },
    {
      id: 3496,
      slug: 'lxml-tutorial-parsing-html-and-xml-documents',
      createdAt: '2024-07-03T07:44:20.216Z',
      updatedAt: '2026-02-25T06:46:28.205Z',
      publishedAt: '2026-02-25T06:46:29.629Z',
      locale: 'en',
      documentId: 'gyn44an78dn6f9gf4vsjrmhs',
    },
    {
      id: 4154,
      slug: 'whats-the-fastest-gateway-to-getting-online-votes',
      createdAt: '2024-07-03T07:44:29.210Z',
      updatedAt: '2026-05-26T09:46:09.826Z',
      publishedAt: '2026-05-26T09:46:15.047Z',
      locale: 'en',
      documentId: 'j61octp79g74d72i32ftmowo',
    },
    {
      id: 3480,
      slug: 'what-to-do-if-craigslist-ip-blocked-you',
      createdAt: '2024-07-03T07:44:40.732Z',
      updatedAt: '2026-02-20T13:27:08.461Z',
      publishedAt: '2026-02-20T13:27:11.409Z',
      locale: 'en',
      documentId: 'lbnbbhpmhgknxsrh99i6wehm',
    },
    {
      id: 4229,
      slug: 'how-to-unblock-match-com-with-residential-proxies',
      createdAt: '2024-07-03T07:44:48.855Z',
      updatedAt: '2026-06-05T08:49:41.860Z',
      publishedAt: '2026-06-05T08:49:42.631Z',
      locale: 'en',
      documentId: 'kwkxcodpbtgohe4ji2y1ywyl',
    },
    {
      id: 2414,
      slug: 'scraping-amazon-with-residential-proxies',
      createdAt: '2024-07-03T07:44:52.471Z',
      updatedAt: '2025-05-21T11:49:07.778Z',
      publishedAt: '2025-05-21T11:49:08.335Z',
      locale: 'en',
      documentId: 'dpfsffooupha5xov8h65ys7j',
    },
    {
      id: 3938,
      slug: 'alternative-data-scraping',
      createdAt: '2024-07-03T07:44:58.772Z',
      updatedAt: '2026-04-30T11:16:09.299Z',
      publishedAt: '2026-04-30T11:16:10.348Z',
      locale: 'en',
      documentId: 'w3ne9gf6oxyct9gnjd2wsn9x',
    },
    {
      id: 3939,
      slug: 'all-in-one-bot-review',
      createdAt: '2024-07-03T07:45:02.700Z',
      updatedAt: '2026-04-30T11:17:38.062Z',
      publishedAt: '2026-04-30T11:17:38.841Z',
      locale: 'en',
      documentId: 'pky0qbivybs03j1zq1jemptk',
    },
    {
      id: 3943,
      slug: 'another-nike-bot-nike-snkrs-bot-review',
      createdAt: '2024-07-03T07:45:10.883Z',
      updatedAt: '2026-04-30T11:22:51.962Z',
      publishedAt: '2026-04-30T11:22:52.853Z',
      locale: 'en',
      documentId: 'i6fzyephrhi13qjxmqg4o4tk',
    },
    {
      id: 2507,
      slug: 'using-automatic-instagram-likes-to-your-advantage',
      createdAt: '2024-07-03T07:45:13.364Z',
      updatedAt: '2025-06-05T10:59:20.650Z',
      publishedAt: '2025-06-05T10:59:21.207Z',
      locale: 'en',
      documentId: 'hhee5z70v7pgok290vdfe150',
    },
    {
      id: 4163,
      slug: 'unblock-instagram-with-a-proxy',
      createdAt: '2024-07-03T07:45:19.405Z',
      updatedAt: '2026-05-26T10:07:22.940Z',
      publishedAt: '2026-05-26T10:07:23.900Z',
      locale: 'en',
      documentId: 'p33irf27g3b1kkb0pirziz05',
    },
    {
      id: 3301,
      slug: 'snkrs-proxies',
      createdAt: '2024-07-03T07:45:24.431Z',
      updatedAt: '2026-01-19T11:47:02.946Z',
      publishedAt: '2026-01-19T11:47:03.580Z',
      locale: 'en',
      documentId: 'onnobjcypgjfit23y10zy9oq',
    },
    {
      id: 1623,
      slug: 'proxies-for-instagram-bots-and-how-to-get-them',
      createdAt: '2024-07-03T07:45:27.039Z',
      updatedAt: '2025-01-31T10:59:23.917Z',
      publishedAt: '2025-01-31T10:59:24.310Z',
      locale: 'en',
      documentId: 'dt272l0aysf4qng0280qjmhf',
    },
    {
      id: 1986,
      slug: 'this-is-as-close-as-you-will-ever-get-to-an-ip-scrambler',
      createdAt: '2024-07-03T07:45:30.083Z',
      updatedAt: '2025-03-04T11:38:52.917Z',
      publishedAt: '2025-03-04T11:38:53.554Z',
      locale: 'en',
      documentId: 'nlm0324amyootoe4e87s4dii',
    },
    {
      id: 2125,
      slug: 'unscrapable-websites',
      createdAt: '2024-07-03T07:45:34.961Z',
      updatedAt: '2025-03-20T13:18:42.585Z',
      publishedAt: '2025-03-20T13:18:43.099Z',
      locale: 'en',
      documentId: 'h3po5gspb1o2mgs71atv6uim',
    },
    {
      id: 3840,
      slug: 'how-to-get-into-the-sneaker-game',
      createdAt: '2024-07-03T07:45:36.933Z',
      updatedAt: '2026-04-17T06:33:35.438Z',
      publishedAt: '2026-04-17T06:33:36.374Z',
      locale: 'en',
      documentId: 'akis0oxbnl4c1niulls0gz6h',
    },
    {
      id: 3201,
      slug: 'scraping-youtube-comments',
      createdAt: '2024-07-03T07:45:45.549Z',
      updatedAt: '2025-12-29T10:14:16.441Z',
      publishedAt: '2025-12-29T10:14:17.678Z',
      locale: 'en',
      documentId: 'cnhi6n2osuzefj6r4pogt6dw',
    },
    {
      id: 643,
      slug: 'whats-the-difference-between-ipv4-and-ipv6',
      createdAt: '2024-07-03T07:46:02.678Z',
      updatedAt: '2024-07-16T14:09:21.951Z',
      publishedAt: '2024-07-03T07:46:01.846Z',
      locale: 'en',
      documentId: 'ivzxeegqenmoti3l52ifn0gw',
    },
    {
      id: 4275,
      slug: 'how-to-generate-a-random-ip-address-for-every-connection',
      createdAt: '2024-07-03T07:46:12.649Z',
      updatedAt: '2026-06-09T13:44:56.096Z',
      publishedAt: '2026-06-09T13:44:57.368Z',
      locale: 'en',
      documentId: 'iw4jz0fx6h60d2mpp7yewn84',
    },
    {
      id: 3173,
      slug: 'telegram-automation',
      createdAt: '2024-07-03T07:46:20.011Z',
      updatedAt: '2025-12-22T13:25:04.085Z',
      publishedAt: '2025-12-22T13:25:05.206Z',
      locale: 'en',
      documentId: 'c0b39v2iey7eokieswx5d32j',
    },
    {
      id: 3555,
      slug: 'manage-your-business-reputation-with-serp-scraping-api',
      createdAt: '2024-07-03T07:46:32.362Z',
      updatedAt: '2026-03-05T12:06:17.323Z',
      publishedAt: '2026-03-05T12:06:18.065Z',
      locale: 'en',
      documentId: 'y23f4nwbxwle6bnn44vcdwd3',
    },
    {
      id: 2443,
      slug: 'how-to-scrape-youtube-search-results-with-web-scraping-api',
      createdAt: '2024-07-03T07:47:00.711Z',
      updatedAt: '2025-05-29T12:29:09.464Z',
      publishedAt: '2025-05-29T12:29:15.052Z',
      locale: 'en',
      documentId: 'jzpsjvaj6yppdrtoh39ow53q',
    },
    {
      id: 3356,
      slug: 'conquer-tiktok-with-proxies',
      createdAt: '2024-07-03T07:47:04.946Z',
      updatedAt: '2026-01-30T09:32:46.815Z',
      publishedAt: '2026-01-30T09:32:48.291Z',
      locale: 'en',
      documentId: 'ixc4cl2klpkbtu6qg5u4qc16',
    },
    {
      id: 2559,
      slug: 'how-an-amazon-proxy-helps-scrapers-and-analysts',
      createdAt: '2024-07-03T07:47:12.203Z',
      updatedAt: '2025-06-16T07:37:33.368Z',
      publishedAt: '2025-06-16T07:37:34.044Z',
      locale: 'en',
      documentId: 'fvyccqrq3x7hwhhcbqkex0gu',
    },
    {
      id: 1968,
      slug: 'how-a-residential-proxy-network-helps-ad-verification',
      createdAt: '2024-07-03T07:47:24.050Z',
      updatedAt: '2025-03-03T10:06:12.985Z',
      publishedAt: '2025-03-03T10:06:13.765Z',
      locale: 'en',
      documentId: 'n1ziw3kecg1ld587w50l06mw',
    },
    {
      id: 4328,
      slug: 'do-you-need-a-wechat-proxy',
      createdAt: '2024-07-03T07:47:28.271Z',
      updatedAt: '2026-06-11T10:52:39.926Z',
      publishedAt: '2026-06-11T10:52:40.729Z',
      locale: 'en',
      documentId: 'qgwgqp3felxvaf005ot71yc7',
    },
    {
      id: 1969,
      slug: 'what-is-a-transparent-proxy',
      createdAt: '2024-07-03T07:47:35.239Z',
      updatedAt: '2025-03-03T10:09:27.547Z',
      publishedAt: '2025-03-03T10:09:28.059Z',
      locale: 'en',
      documentId: 'gdouky6pwsx7a3nprk64ht0k',
    },
    {
      id: 4112,
      slug: 'the-difference-between-a-reverse-proxy-and-a-forward-proxy',
      createdAt: '2024-07-03T07:47:40.969Z',
      updatedAt: '2026-05-19T10:48:09.793Z',
      publishedAt: '2026-05-19T10:48:12.060Z',
      locale: 'en',
      documentId: 'wgqgtq3e6za3docndzej2gw1',
    },
    {
      id: 4235,
      slug: 'how-ip-hopping-can-help-you-bounce-your-ip-address',
      createdAt: '2024-07-03T07:47:47.379Z',
      updatedAt: '2026-06-05T12:41:14.874Z',
      publishedAt: '2026-06-05T12:41:15.680Z',
      locale: 'en',
      documentId: 'rtyrwg0o8zvtvr1nuwxctne2',
    },
    {
      id: 4324,
      slug: 'scrapy-vs-beautifulsoup',
      createdAt: '2024-07-03T07:48:02.268Z',
      updatedAt: '2026-06-11T08:07:56.807Z',
      publishedAt: '2026-06-11T08:07:57.777Z',
      locale: 'en',
      documentId: 'lehjag9dx2tw98thz5fsx28k',
    },
    {
      id: 3954,
      slug: 'better-nike-bot-and-bnb-review',
      createdAt: '2024-07-03T07:48:05.354Z',
      updatedAt: '2026-04-30T11:39:03.770Z',
      publishedAt: '2026-04-30T11:39:04.564Z',
      locale: 'en',
      documentId: 's7h6votj1xeqwo6nequmviw0',
    },
    {
      id: 3870,
      slug: 'protecting-your-brand-with-a-proxy-network',
      createdAt: '2024-07-03T07:48:23.979Z',
      updatedAt: '2026-04-21T13:17:03.650Z',
      publishedAt: '2026-04-21T13:17:04.698Z',
      locale: 'en',
      documentId: 'bjesuop4w9jk8q7affwli3pe',
    },
    {
      id: 3950,
      slug: 'award-winning-proxy-provider',
      createdAt: '2024-07-03T07:48:26.821Z',
      updatedAt: '2026-04-30T11:33:33.424Z',
      publishedAt: '2026-04-30T11:33:34.359Z',
      locale: 'en',
      documentId: 'q2q91tvon3330fhdltsdbm6e',
    },
    {
      id: 3947,
      slug: 'are-residential-proxies-better-than-a-fake-ip-address',
      createdAt: '2024-07-03T07:48:33.912Z',
      updatedAt: '2026-04-30T11:29:25.842Z',
      publishedAt: '2026-04-30T11:29:26.948Z',
      locale: 'en',
      documentId: 'vlfklrmyplk3cgjlmcjvgtew',
    },
    {
      id: 670,
      slug: 'use-soundcloud-proxy',
      createdAt: '2024-07-03T07:48:56.842Z',
      updatedAt: '2024-08-07T13:15:26.477Z',
      publishedAt: '2024-07-03T07:48:55.610Z',
      locale: 'en',
      documentId: 'i5y7ei77xqxna84i9qmon2cb',
    },
    {
      id: 4327,
      slug: 'how-to-choose-the-right-selector-for-web-scraping-xpath-vs-css',
      createdAt: '2024-07-03T07:49:03.515Z',
      updatedAt: '2026-06-11T10:17:36.710Z',
      publishedAt: '2026-06-11T10:17:37.756Z',
      locale: 'en',
      documentId: 'ls055ql5mznkxsxpdyhtbcn8',
    },
    {
      id: 2569,
      slug: 'selenium-proxy',
      createdAt: '2024-07-03T07:49:11.783Z',
      updatedAt: '2025-06-17T10:57:03.587Z',
      publishedAt: '2025-06-17T10:57:08.123Z',
      locale: 'en',
      documentId: 'khw29ifzz9fz1bs1v30zap9k',
    },
    {
      id: 3875,
      slug: 'what-is-an-anonymous-proxy',
      createdAt: '2024-07-03T07:49:24.353Z',
      updatedAt: '2026-04-21T13:30:34.865Z',
      publishedAt: '2026-04-21T13:30:36.199Z',
      locale: 'en',
      documentId: 'njgzirovsfbdwq4btn0es9x2',
    },
    {
      id: 1777,
      slug: 'shopping-bots-explained-different-types-and-benefits',
      createdAt: '2024-07-03T07:49:36.126Z',
      updatedAt: '2025-02-07T14:32:10.768Z',
      publishedAt: '2025-02-07T14:32:11.493Z',
      locale: 'en',
      documentId: 'xoo1ryv0637tkw4du6220cbq',
    },
    {
      id: 3946,
      slug: 'anti-bot-systems',
      createdAt: '2024-07-03T07:50:43.849Z',
      updatedAt: '2026-04-30T11:28:12.122Z',
      publishedAt: '2026-04-30T11:28:13.184Z',
      locale: 'en',
      documentId: 'w9tna3dvff3wgy694n7em2n0',
    },
    {
      id: 3325,
      slug: 'what-to-do-when-getting-parsing-errors-in-python',
      createdAt: '2024-07-03T07:50:50.189Z',
      updatedAt: '2026-01-27T12:56:18.450Z',
      publishedAt: '2026-01-27T12:56:20.510Z',
      locale: 'en',
      documentId: 'eggstx7t43715fjar4dlgvhd',
    },
    {
      id: 3290,
      slug: 'most-scraped-websites-2024',
      createdAt: '2024-07-16T15:06:49.336Z',
      updatedAt: '2026-01-15T13:08:26.843Z',
      publishedAt: '2026-01-15T13:08:27.467Z',
      locale: 'en',
      documentId: 'k7l33r7kkx9fsxxowie689hk',
    },
    {
      id: 4087,
      slug: 'externally-managed-environment',
      createdAt: '2024-08-01T07:31:52.903Z',
      updatedAt: '2026-05-18T09:59:04.347Z',
      publishedAt: '2026-05-18T09:59:05.740Z',
      locale: 'en',
      documentId: 'pzgjeli1wmoif07lx2diz1er',
    },
    {
      id: 3989,
      slug: 'benefits-of-completing-id-verification',
      createdAt: '2024-08-07T06:52:27.945Z',
      updatedAt: '2026-05-05T13:17:24.468Z',
      publishedAt: '2026-05-05T13:17:25.233Z',
      locale: 'en',
      documentId: 'da27djr9vtnwizev889w4p9q',
    },
    {
      id: 3513,
      slug: 'how-to-hide-your-ip-address',
      createdAt: '2024-08-12T11:22:46.602Z',
      updatedAt: '2026-02-25T11:45:20.749Z',
      publishedAt: '2026-02-25T11:45:22.860Z',
      locale: 'en',
      documentId: 'qvssllpiouz8jn5e0y2v7fyp',
    },
    {
      id: 2257,
      slug: 'eu-ecommerce-strengths-and-weaknesses',
      createdAt: '2024-08-20T12:11:39.986Z',
      updatedAt: '2025-04-07T13:03:08.583Z',
      publishedAt: '2025-04-07T13:03:09.063Z',
      locale: 'en',
      documentId: 'cscwdtr4iybs3c29c5v7eo2u',
    },
    {
      id: 2195,
      slug: 'pricing-leaders',
      createdAt: '2024-08-20T12:38:12.545Z',
      updatedAt: '2025-04-07T08:08:39.541Z',
      publishedAt: '2025-04-07T08:08:40.005Z',
      locale: 'en',
      documentId: 'aqox3m6kmhgssu658pqdj3wq',
    },
    {
      id: 2198,
      slug: 'europe-leads-global-ecommerce',
      createdAt: '2024-08-20T12:50:08.659Z',
      updatedAt: '2025-04-07T08:11:37.792Z',
      publishedAt: '2025-04-07T08:11:38.358Z',
      locale: 'en',
      documentId: 'fqsgezbq3vg0b6uqmcgz1rpd',
    },
    {
      id: 2197,
      slug: 'importance-of-transparency-in-europe',
      createdAt: '2024-08-20T12:56:56.459Z',
      updatedAt: '2025-04-07T08:09:32.998Z',
      publishedAt: '2025-04-07T08:09:33.524Z',
      locale: 'en',
      documentId: 'zbw8wsd7db6ltomutfdip1wl',
    },
    {
      id: 2235,
      slug: 'north-america-most-advanced-reviews',
      createdAt: '2024-08-20T13:15:56.162Z',
      updatedAt: '2025-04-07T12:32:15.334Z',
      publishedAt: '2025-04-07T12:32:15.874Z',
      locale: 'en',
      documentId: 'i3zr8knquk9pu478cvmk3g1g',
    },
    {
      id: 4095,
      slug: 'curl-post-file',
      createdAt: '2024-08-21T09:58:00.167Z',
      updatedAt: '2026-05-18T10:14:46.299Z',
      publishedAt: '2026-05-18T10:14:47.348Z',
      locale: 'en',
      documentId: 'p4qvzwnefd50fxkdnatctqz0',
    },
    {
      id: 2199,
      slug: 'fashion-category-index',
      createdAt: '2024-08-21T12:17:24.369Z',
      updatedAt: '2025-04-07T08:12:18.024Z',
      publishedAt: '2025-04-07T08:12:18.504Z',
      locale: 'en',
      documentId: 'w1eo7belez0o8ox1a7mehy3n',
    },
    {
      id: 3965,
      slug: 'curl-download-files',
      createdAt: '2024-08-23T12:58:36.175Z',
      updatedAt: '2026-04-30T11:59:35.136Z',
      publishedAt: '2026-04-30T11:59:37.383Z',
      locale: 'en',
      documentId: 'xzf6fo7yghgp41ge3rf9u0ml',
    },
    {
      id: 4091,
      slug: 'javascript-heap-out-of-memory',
      createdAt: '2024-08-26T11:04:05.157Z',
      updatedAt: '2026-05-18T09:59:42.067Z',
      publishedAt: '2026-05-18T09:59:44.010Z',
      locale: 'en',
      documentId: 'qll6lizlp73t132zk4fdke4a',
    },
    {
      id: 4096,
      slug: 'curl-send-headers',
      createdAt: '2024-08-27T08:29:35.731Z',
      updatedAt: '2026-05-18T10:15:08.556Z',
      publishedAt: '2026-05-18T10:15:09.906Z',
      locale: 'en',
      documentId: 'yxdcng60qfhr4n7cw11ipn2g',
    },
    {
      id: 750,
      slug: 'python-pandas-tutorial',
      createdAt: '2024-09-10T07:00:33.798Z',
      updatedAt: '2024-09-10T10:58:55.247Z',
      publishedAt: '2024-09-10T10:27:22.764Z',
      locale: 'en',
      documentId: 'oxl5do7y4qmeqrmp7p1q1p15',
    },
    {
      id: 4308,
      slug: 'how-to-inspect-element',
      createdAt: '2024-09-13T08:25:28.757Z',
      updatedAt: '2026-06-10T13:34:55.732Z',
      publishedAt: '2026-06-10T13:34:56.787Z',
      locale: 'en',
      documentId: 'h0546y7ee1zkvusk6wdwfngs',
    },
    {
      id: 754,
      slug: 'what-are-proxies-for-bots',
      createdAt: '2024-10-01T05:42:26.570Z',
      updatedAt: '2024-10-01T05:42:30.418Z',
      publishedAt: '2024-10-01T05:42:30.387Z',
      locale: 'en',
      documentId: 'd6l83665h75haoh0yb7a56bq',
    },
    {
      id: 3878,
      slug: 'what-is-proxy-hostname',
      createdAt: '2024-10-01T05:57:37.587Z',
      updatedAt: '2026-04-21T13:34:34.685Z',
      publishedAt: '2026-04-21T13:34:35.791Z',
      locale: 'en',
      documentId: 'mcxvkaqba0mlzd1dcraf8njg',
    },
    {
      id: 4326,
      slug: 'how-to-resell-proxies-a-comprehensive-guide',
      createdAt: '2024-10-01T06:34:17.447Z',
      updatedAt: '2026-06-11T10:15:08.160Z',
      publishedAt: '2026-06-11T10:15:08.957Z',
      locale: 'en',
      documentId: 's3s6oqojg94fdsbrc8iuf11s',
    },
    {
      id: 4316,
      slug: 'how-to-check-if-a-website-allows-scraping',
      createdAt: '2024-10-01T06:46:24.282Z',
      updatedAt: '2026-06-11T07:49:20.811Z',
      publishedAt: '2026-06-11T07:49:21.652Z',
      locale: 'en',
      documentId: 'pso58ogj2ku2mhcqoqk947yx',
    },
    {
      id: 4377,
      slug: 'how-to-scrape-products-from-ecommerce-sites',
      createdAt: '2024-10-02T07:34:57.686Z',
      updatedAt: '2026-06-16T13:09:53.980Z',
      publishedAt: '2026-06-16T13:09:54.779Z',
      locale: 'en',
      documentId: 'luoonmqgusaxwb5tekegofkw',
    },
    {
      id: 2056,
      slug: 'what-is-a-proxy-server-for-wifi',
      createdAt: '2024-10-02T08:14:15.582Z',
      updatedAt: '2025-03-14T09:54:04.037Z',
      publishedAt: '2025-03-14T09:54:04.710Z',
      locale: 'en',
      documentId: 'ivn35p0vm0iluqkjwh09k2pv',
    },
    {
      id: 3934,
      slug: 'ai-coding-tools',
      createdAt: '2024-10-04T12:47:13.692Z',
      updatedAt: '2026-04-30T11:08:30.852Z',
      publishedAt: '2026-04-30T11:08:31.707Z',
      locale: 'en',
      documentId: 'p23svzctsvtvskn98u76weav',
    },
    {
      id: 2032,
      slug: 'what-is-a-proxy-browser-a-comprehensive-guide',
      createdAt: '2024-10-10T07:58:51.321Z',
      updatedAt: '2025-03-12T08:36:08.114Z',
      publishedAt: '2025-03-12T08:36:08.610Z',
      locale: 'en',
      documentId: 'cbfe1ur18w3ajrj5zhrr7h9i',
    },
    {
      id: 4156,
      slug: 'why-is-chrome-blocking-websites',
      createdAt: '2024-10-10T09:55:27.743Z',
      updatedAt: '2026-05-26T09:52:12.692Z',
      publishedAt: '2026-05-26T09:52:13.572Z',
      locale: 'en',
      documentId: 'crrodyu5vx7gm56v70uz3bli',
    },
    {
      id: 1567,
      slug: 'session-expired-on-gmail',
      createdAt: '2024-10-10T10:13:52.649Z',
      updatedAt: '2025-01-28T07:20:27.266Z',
      publishedAt: '2025-01-28T07:20:27.508Z',
      locale: 'en',
      documentId: 'aphtkhy7exdmm19ke24cpq66',
    },
    {
      id: 1949,
      slug: 'how-to-avoid-amazon-captcha',
      createdAt: '2024-10-10T10:51:54.704Z',
      updatedAt: '2025-02-27T07:45:12.034Z',
      publishedAt: '2025-02-27T07:45:13.486Z',
      locale: 'en',
      documentId: 'dw63dyb5pjwezu3fi0hx0fmw',
    },
    {
      id: 767,
      slug: 'what-is-data-cleaning',
      createdAt: '2024-10-10T11:18:12.014Z',
      updatedAt: '2024-10-10T11:18:45.605Z',
      publishedAt: '2024-10-10T11:18:45.578Z',
      locale: 'en',
      documentId: 'c0hxl9qsiuc0v0vbaotkv81z',
    },
    {
      id: 4313,
      slug: 'how-to-set-proxy-in-microsoft-edge',
      createdAt: '2024-10-10T11:24:05.245Z',
      updatedAt: '2026-06-10T13:49:57.253Z',
      publishedAt: '2026-06-10T13:50:00.112Z',
      locale: 'en',
      documentId: 'dpote7lifw6zjvt8p2cy6k3e',
    },
    {
      id: 3487,
      slug: 'how-to-use-shadowrocket-on-iphone',
      createdAt: '2024-10-10T11:28:42.748Z',
      updatedAt: '2026-02-20T14:05:00.541Z',
      publishedAt: '2026-02-20T14:05:01.339Z',
      locale: 'en',
      documentId: 'vgctpvauc6epmsacxgtqenwt',
    },
    {
      id: 3508,
      slug: 'how-to-scrape-hotel-listings',
      createdAt: '2024-10-10T11:45:13.713Z',
      updatedAt: '2026-02-25T08:52:25.430Z',
      publishedAt: '2026-02-25T08:52:26.615Z',
      locale: 'en',
      documentId: 'pgdzs5l89zb3j9i7ms0pt9e5',
    },
    {
      id: 4093,
      slug: 'web-scraping-job-postings-python',
      createdAt: '2024-10-10T12:02:59.489Z',
      updatedAt: '2026-05-18T10:14:36.683Z',
      publishedAt: '2026-05-18T10:14:41.347Z',
      locale: 'en',
      documentId: 'd4j4arnly85bol5tyuv4w8m7',
    },
    {
      id: 3936,
      slug: 'ai-data-processing',
      createdAt: '2024-10-10T12:33:17.781Z',
      updatedAt: '2026-04-30T11:12:40.606Z',
      publishedAt: '2026-04-30T11:12:41.400Z',
      locale: 'en',
      documentId: 'fvwl6cbm1r6auprfesd3ausf',
    },
    {
      id: 774,
      slug: 'llm-for-data-analysis',
      createdAt: '2024-10-10T12:52:56.904Z',
      updatedAt: '2024-10-10T12:53:19.355Z',
      publishedAt: '2024-10-10T12:53:19.301Z',
      locale: 'en',
      documentId: 'xmyyd0en1h7ylj9kg3irub2f',
    },
    {
      id: 4361,
      slug: 'ecommerce-with-frequent-price-changes',
      createdAt: '2024-10-18T09:41:12.385Z',
      updatedAt: '2026-06-16T06:58:30.491Z',
      publishedAt: '2026-06-16T06:58:31.435Z',
      locale: 'en',
      documentId: 'w7irdfvr1me9hnrbwz72dcvj',
    },
    {
      id: 3805,
      slug: 'fix-your-ip-address-has-been-banned-error',
      createdAt: '2024-10-25T10:58:57.491Z',
      updatedAt: '2026-04-14T07:07:40.745Z',
      publishedAt: '2026-04-14T07:07:41.444Z',
      locale: 'en',
      documentId: 'ti4ajwlf9y8ipvqe4g0o0el0',
    },
    {
      id: 3316,
      slug: 'how-to-scrape-google-images',
      createdAt: '2024-10-28T12:44:14.556Z',
      updatedAt: '2026-01-27T12:54:59.031Z',
      publishedAt: '2026-01-27T12:55:00.585Z',
      locale: 'en',
      documentId: 'kodz7t2wmjp613r13rncaxh8',
    },
    {
      id: 3284,
      slug: 'how-to-scrape-amazon-reviews',
      createdAt: '2024-11-05T09:22:01.304Z',
      updatedAt: '2026-01-15T10:49:35.344Z',
      publishedAt: '2026-01-15T10:49:36.071Z',
      locale: 'en',
      documentId: 'lrmcvcf9zj19yd8wi2kdv6tg',
    },
    {
      id: 3283,
      slug: 'how-to-scrape-amazon-prices',
      createdAt: '2024-11-15T11:14:59.811Z',
      updatedAt: '2026-01-15T10:40:02.810Z',
      publishedAt: '2026-01-15T10:40:03.673Z',
      locale: 'en',
      documentId: 'pstgglwk8tvsgsbmx47z0qo1',
    },
    {
      id: 4362,
      slug: 'truth-behind-black-friday-discounts',
      createdAt: '2024-11-18T09:14:50.708Z',
      updatedAt: '2026-06-16T07:01:33.777Z',
      publishedAt: '2026-06-16T07:01:34.604Z',
      locale: 'en',
      documentId: 'x0a55p1t834m3jcyfen4hmiw',
    },
    {
      id: 2656,
      slug: 'scrape-amazon-asin',
      createdAt: '2024-11-15T11:14:59.811Z',
      updatedAt: '2025-07-09T08:33:36.654Z',
      publishedAt: '2025-07-09T08:33:37.310Z',
      locale: 'en',
      documentId: 'wsmffz4ri6rddbudzqj002a3',
    },
    {
      id: 4303,
      slug: 'playwright-web-scraping',
      createdAt: '2024-07-03T07:38:52.021Z',
      updatedAt: '2026-06-10T13:18:49.828Z',
      publishedAt: '2026-06-10T13:18:51.532Z',
      locale: 'en',
      documentId: 'y05rbfwhcnj4tnpuoshodmy0',
    },
    {
      id: 2760,
      slug: 'javascript-is-now-a-must-for-google-search',
      createdAt: '2024-12-06T16:06:50.537Z',
      updatedAt: '2025-08-13T14:08:30.782Z',
      publishedAt: '2025-08-13T14:08:36.141Z',
      locale: 'en',
      documentId: 'zf6bt2xs41275xuz8oh5s7o2',
    },
    {
      id: 4329,
      slug: 'http-proxy-definition-use-cases-error-solutions',
      createdAt: '2024-12-06T16:06:50.537Z',
      updatedAt: '2026-06-11T10:58:09.758Z',
      publishedAt: '2026-06-11T10:58:10.401Z',
      locale: 'en',
      documentId: 'rlt59z3vy5h5a5r31sr8g3j1',
    },
    {
      id: 4268,
      slug: 'amazon-sorry-something-went-wrong-on-our-end',
      createdAt: '2024-12-06T16:06:50.537Z',
      updatedAt: '2026-06-09T13:15:18.617Z',
      publishedAt: '2026-06-09T13:15:19.380Z',
      locale: 'en',
      documentId: 'sfx6bs9xd1rgs3ya0oylklmm',
    },
    {
      id: 2252,
      slug: 'what-is-web-scraping',
      createdAt: '2024-12-06T16:06:50.537Z',
      updatedAt: '2025-04-07T12:50:59.399Z',
      publishedAt: '2025-04-07T12:50:59.929Z',
      locale: 'en',
      documentId: 'jm1tgqpjgn7y7al60ol4nhiy',
    },
    {
      id: 3369,
      slug: 'python-requests-retry',
      createdAt: '2024-07-03T07:34:50.872Z',
      updatedAt: '2026-01-30T12:20:33.105Z',
      publishedAt: '2026-01-30T12:20:35.395Z',
      locale: 'en',
      documentId: 'xskey4b83jdc3gpccz3thhpo',
    },
    {
      id: 3516,
      slug: 'google-ads-competitor-analysis',
      createdAt: '2024-07-03T07:34:50.872Z',
      updatedAt: '2026-02-25T14:40:34.409Z',
      publishedAt: '2026-02-25T14:40:35.648Z',
      locale: 'en',
      documentId: 'erapzk2hsryptld204kgcl9o',
    },
    {
      id: 3365,
      slug: 'python-web-scraping',
      createdAt: '2025-02-28T08:11:25.330Z',
      updatedAt: '2026-01-30T11:43:58.787Z',
      publishedAt: '2026-01-30T11:44:01.348Z',
      locale: 'en',
      documentId: 'kkbab8nrrga0i9hsudktkm6w',
    },
    {
      id: 2417,
      slug: 'web-scraping-with-cheerio-and-node-js',
      createdAt: '2025-03-04T11:26:50.233Z',
      updatedAt: '2025-05-23T06:17:41.449Z',
      publishedAt: '2025-05-23T06:17:42.144Z',
      locale: 'en',
      documentId: 'ekre99i6bnpbddqtakq183hc',
    },
    {
      id: 4337,
      slug: 'what-is-an-api',
      createdAt: '2025-03-06T11:55:53.690Z',
      updatedAt: '2026-06-11T12:37:25.013Z',
      publishedAt: '2026-06-11T12:37:33.468Z',
      locale: 'en',
      documentId: 'b6ddasxndw4dnoxgijqoqyjm',
    },
    {
      id: 4305,
      slug: 'difference-between-socks5-vs-http-proxy',
      createdAt: '2025-03-06T12:49:52.920Z',
      updatedAt: '2026-06-10T13:23:28.908Z',
      publishedAt: '2026-06-10T13:23:29.895Z',
      locale: 'en',
      documentId: 'm8y48zxij8f83pljo6w2nedv',
    },
    {
      id: 4311,
      slug: 'what-is-screen-scraping',
      createdAt: '2025-03-06T13:48:33.812Z',
      updatedAt: '2026-06-10T13:47:26.869Z',
      publishedAt: '2026-06-10T13:47:27.902Z',
      locale: 'en',
      documentId: 'mho8y3eahf0asmgsgbmagxs6',
    },
    {
      id: 2778,
      slug: 'how-ai-secretly-gathers-data',
      createdAt: '2025-03-12T06:57:08.818Z',
      updatedAt: '2025-08-18T10:22:47.710Z',
      publishedAt: '2025-08-18T10:22:48.173Z',
      locale: 'en',
      documentId: 'cd0a5ysr64atgm6z8owu1w3e',
    },
    {
      id: 4086,
      slug: 'how-to-scrape-google-news',
      createdAt: '2025-03-13T09:53:41.121Z',
      updatedAt: '2026-05-18T09:58:58.359Z',
      publishedAt: '2026-05-18T09:59:01.083Z',
      locale: 'en',
      documentId: 'kepc61cpp6icfvfl483r3ybr',
    },
    {
      id: 3515,
      slug: 'what-is-socks-proxy',
      createdAt: '2025-03-14T12:40:54.735Z',
      updatedAt: '2026-02-25T12:52:12.020Z',
      publishedAt: '2026-02-25T12:52:13.104Z',
      locale: 'en',
      documentId: 'etki2ft3kgrpzvvphjbt7jav',
    },
    {
      id: 3941,
      slug: 'amazon-price-scraping-with-google-sheets',
      createdAt: '2025-03-14T14:11:10.935Z',
      updatedAt: '2026-04-30T11:20:42.165Z',
      publishedAt: '2026-04-30T11:20:43.186Z',
      locale: 'en',
      documentId: 'sd8nrngmhty3dtiftyezvwrf',
    },
    {
      id: 4309,
      slug: 'web-scraping-project-ideas',
      createdAt: '2025-03-20T08:59:31.717Z',
      updatedAt: '2026-06-10T13:44:06.086Z',
      publishedAt: '2026-06-10T13:44:06.973Z',
      locale: 'en',
      documentId: 'hxscof2yxdaqz4ahc6nxk77d',
    },
    {
      id: 3951,
      slug: 'beautiful-soup-web-scraping',
      createdAt: '2025-03-25T08:42:04.919Z',
      updatedAt: '2026-04-30T11:35:09.269Z',
      publishedAt: '2026-04-30T11:35:11.012Z',
      locale: 'en',
      documentId: 'fda5k2p8qer2nkbm4tpi2g9v',
    },
    {
      id: 2276,
      slug: 'web-scraping-in-r',
      createdAt: '2025-03-27T12:35:47.731Z',
      updatedAt: '2025-04-10T07:51:56.611Z',
      publishedAt: '2025-04-10T07:51:57.378Z',
      locale: 'en',
      documentId: 'mf60otk8gl53vyrhz3ox2dw7',
    },
    {
      id: 4321,
      slug: 'web-scraping-javascript',
      createdAt: '2025-03-28T08:35:39.652Z',
      updatedAt: '2026-06-11T07:59:13.665Z',
      publishedAt: '2026-06-11T07:59:14.941Z',
      locale: 'en',
      documentId: 'imlwa0cqc93tw6lnhze51g17',
    },
    {
      id: 4307,
      slug: 'crawling-vs-scraping',
      createdAt: '2025-03-28T11:11:30.600Z',
      updatedAt: '2026-06-10T13:31:46.446Z',
      publishedAt: '2026-06-10T13:31:47.778Z',
      locale: 'en',
      documentId: 't4n5t6zwea2aht2fp0kuuy8q',
    },
    {
      id: 4282,
      slug: 'amazon-price-scraping-with-excel',
      createdAt: '2025-03-31T08:00:18.446Z',
      updatedAt: '2026-06-10T06:54:13.882Z',
      publishedAt: '2026-06-10T06:54:15.581Z',
      locale: 'en',
      documentId: 'sgrkg2388db8l7u6sr27u61d',
    },
    {
      id: 3358,
      slug: 'what-is-data-scraping',
      createdAt: '2025-03-28T07:03:05.087Z',
      updatedAt: '2026-01-30T09:47:29.662Z',
      publishedAt: '2026-01-30T09:47:36.830Z',
      locale: 'en',
      documentId: 'obpia3d1p6hjigrbcch2fyhq',
    },
    {
      id: 2650,
      slug: 'smartproxy-is-now-decodo',
      createdAt: '2025-04-08T13:45:38.784Z',
      updatedAt: '2025-07-04T07:49:47.261Z',
      publishedAt: '2025-07-04T07:49:48.085Z',
      locale: 'en',
      documentId: 'lbopcpy4jqzc0ggkmcai33sv',
    },
    {
      id: 4104,
      slug: 'new-web-scraping-api',
      createdAt: '2025-04-08T16:06:56.580Z',
      updatedAt: '2026-05-18T11:29:55.948Z',
      publishedAt: '2026-05-18T11:29:56.850Z',
      locale: 'en',
      documentId: 'xtcg6l91cf8ny7mio7wmovo1',
    },
    {
      id: 4111,
      slug: 'proxy-for-scraping-amazon',
      createdAt: '2025-04-29T11:07:08.288Z',
      updatedAt: '2026-05-19T09:48:07.709Z',
      publishedAt: '2026-05-19T09:48:09.712Z',
      locale: 'en',
      documentId: 'o1cv1gshay3c7qf69j4lmc65',
    },
    {
      id: 4090,
      slug: 'how-to-find-proxy-server-address',
      createdAt: '2025-05-05T11:29:19.359Z',
      updatedAt: '2026-05-18T09:59:18.803Z',
      publishedAt: '2026-05-18T09:59:20.182Z',
      locale: 'en',
      documentId: 'bktr99aba6zo1mxtlm3rklc8',
    },
    {
      id: 3880,
      slug: 'what-is-a-dedicated-proxy',
      createdAt: '2025-05-06T05:50:33.313Z',
      updatedAt: '2026-04-21T13:37:12.378Z',
      publishedAt: '2026-04-21T13:37:13.229Z',
      locale: 'en',
      documentId: 'bh8m0z6pecxmxhybjnrp3ro7',
    },
    {
      id: 2818,
      slug: 'how-to-scrape-google-scholar',
      createdAt: '2025-05-12T08:21:05.477Z',
      updatedAt: '2025-09-10T05:51:50.374Z',
      publishedAt: '2025-09-10T05:51:51.152Z',
      locale: 'en',
      documentId: 'gejc0hoz3w6ondyvugi2l3ak',
    },
    {
      id: 4360,
      slug: 'go-vs-python',
      createdAt: '2025-05-13T06:45:05.289Z',
      updatedAt: '2026-06-16T06:52:10.846Z',
      publishedAt: '2026-06-16T06:52:12.312Z',
      locale: 'en',
      documentId: 'km28ewu49o80w73nypwj5jmw',
    },
    {
      id: 4297,
      slug: 'how-to-scrape-bing-search',
      createdAt: '2025-05-15T10:11:24.161Z',
      updatedAt: '2026-06-10T11:28:27.079Z',
      publishedAt: '2026-06-10T11:28:28.505Z',
      locale: 'en',
      documentId: 'plogm59y6kd79wusj58oyabm',
    },
    {
      id: 3332,
      slug: 'how-to-scrape-google-shopping',
      createdAt: '2025-05-27T13:51:15.106Z',
      updatedAt: '2026-01-27T12:58:09.096Z',
      publishedAt: '2026-01-27T12:58:11.078Z',
      locale: 'en',
      documentId: 'fggytlig7h2jkxi2hbmjc5ph',
    },
    {
      id: 3935,
      slug: 'ai-training-data',
      createdAt: '2025-05-30T10:10:02.736Z',
      updatedAt: '2026-04-30T11:10:04.924Z',
      publishedAt: '2026-04-30T11:10:05.870Z',
      locale: 'en',
      documentId: 'qygy5mw07n2jw35tvb5jzgy3',
    },
    {
      id: 3381,
      slug: 'how-to-train-llm-with-your-own-data',
      createdAt: '2025-06-02T11:35:03.509Z',
      updatedAt: '2026-01-30T12:59:14.921Z',
      publishedAt: '2026-01-30T12:59:16.806Z',
      locale: 'en',
      documentId: 'hr0insf1xostbps5kypovglp',
    },
    {
      id: 4358,
      slug: 'how-to-scrape-zoominfo',
      createdAt: '2025-06-09T10:25:44.494Z',
      updatedAt: '2026-06-16T06:49:55.110Z',
      publishedAt: '2026-06-16T06:49:58.056Z',
      locale: 'en',
      documentId: 'rq7n78a1pwv1tlq8ylgs0966',
    },
    {
      id: 3931,
      slug: 'ai-data-mapping-explained',
      createdAt: '2025-06-12T07:02:58.537Z',
      updatedAt: '2026-04-30T11:02:33.585Z',
      publishedAt: '2026-04-30T11:02:34.945Z',
      locale: 'en',
      documentId: 'rxtyhyik3q6s0cq01fuxdis0',
    },
    {
      id: 4089,
      slug: 'how-to-test-proxies',
      createdAt: '2025-06-20T11:35:16.554Z',
      updatedAt: '2026-05-18T09:59:14.549Z',
      publishedAt: '2026-05-18T09:59:15.620Z',
      locale: 'en',
      documentId: 'n9q0xlesvwqdulc5g4l6gr9k',
    },
    {
      id: 3306,
      slug: 'how-to-scrape-zillow',
      createdAt: '2025-06-23T11:07:47.083Z',
      updatedAt: '2026-01-20T14:06:11.391Z',
      publishedAt: '2026-01-20T14:06:12.212Z',
      locale: 'en',
      documentId: 'fc8b5u6x0rcyovqik6k8nkv5',
    },
    {
      id: 2630,
      slug: 'how-to-scrape-youtube-search-results',
      createdAt: '2025-06-23T14:17:04.772Z',
      updatedAt: '2025-06-27T12:43:01.247Z',
      publishedAt: '2025-06-27T12:43:02.596Z',
      locale: 'en',
      documentId: 'dqhcg4fsn1dmo2czdeqpiyyr',
    },
    {
      id: 2817,
      slug: 'how-to-scrape-google-finance',
      createdAt: '2025-06-25T10:15:20.133Z',
      updatedAt: '2025-09-10T05:51:01.955Z',
      publishedAt: '2025-09-10T05:51:03.000Z',
      locale: 'en',
      documentId: 'lrlawv78e1b66ckpf2xyvi74',
    },
    {
      id: 4359,
      slug: 'scrape-walmart-data',
      createdAt: '2025-07-03T10:38:00.337Z',
      updatedAt: '2026-06-16T06:51:08.291Z',
      publishedAt: '2026-06-16T06:51:09.903Z',
      locale: 'en',
      documentId: 'r2u4uber9s1mofgb5rbnhbmj',
    },
    {
      id: 2931,
      slug: 'scrape-target-product-data',
      createdAt: '2025-07-03T12:24:08.948Z',
      updatedAt: '2025-10-10T08:57:54.667Z',
      publishedAt: '2025-10-10T08:57:56.271Z',
      locale: 'en',
      documentId: 'yejpgggbzmtjl39s4cglrjzt',
    },
    {
      id: 3808,
      slug: 'how-to-scrape-google-play-store',
      createdAt: '2025-07-04T06:50:25.033Z',
      updatedAt: '2026-04-14T07:13:12.736Z',
      publishedAt: '2026-04-14T07:13:13.555Z',
      locale: 'en',
      documentId: 'wldlnnm6u88ez7g3j0lg6bdx',
    },
    {
      id: 3389,
      slug: 'how-to-build-a-labubu-bot',
      createdAt: '2025-07-09T08:37:36.599Z',
      updatedAt: '2026-01-30T13:13:07.390Z',
      publishedAt: '2026-01-30T13:13:09.558Z',
      locale: 'en',
      documentId: 'dig5a2l5i1ogfqclaw2dqy24',
    },
    {
      id: 4088,
      slug: 'error-1015',
      createdAt: '2025-07-15T07:00:05.923Z',
      updatedAt: '2026-05-18T09:59:08.762Z',
      publishedAt: '2026-05-18T09:59:10.232Z',
      locale: 'en',
      documentId: 'y74c0ynicrwbpomyixru5rta',
    },
    {
      id: 2932,
      slug: 'how-to-train-an-ai-model',
      createdAt: '2025-07-15T12:47:07.060Z',
      updatedAt: '2025-10-10T08:59:15.385Z',
      publishedAt: '2025-10-10T08:59:15.964Z',
      locale: 'en',
      documentId: 'swmsjl03psluh4ddp1bxh1mz',
    },
    {
      id: 3377,
      slug: 'best-ai-data-collection-tools',
      createdAt: '2025-07-21T07:01:08.900Z',
      updatedAt: '2026-01-30T12:49:11.221Z',
      publishedAt: '2026-01-30T12:49:13.302Z',
      locale: 'en',
      documentId: 'phgyb68zmxr8mqxu4cgjtj3y',
    },
    {
      id: 2775,
      slug: 'how-companies-use-external-data-in-the-us',
      createdAt: '2025-07-24T06:23:59.025Z',
      updatedAt: '2025-08-18T10:15:18.991Z',
      publishedAt: '2025-08-18T10:15:19.817Z',
      locale: 'en',
      documentId: 'cyf9f3k1esjwuz9kvyql40fm',
    },
    {
      id: 4050,
      slug: 'how-to-scrape-google-lens',
      createdAt: '2025-07-24T10:38:55.095Z',
      updatedAt: '2026-05-08T09:19:59.758Z',
      publishedAt: '2026-05-08T09:20:00.730Z',
      locale: 'en',
      documentId: 'lf8y200iwoeq3qetxqxf5dk2',
    },
    {
      id: 4077,
      slug: 'web-scraping-services',
      createdAt: '2025-07-25T11:54:52.868Z',
      updatedAt: '2026-05-13T13:32:32.322Z',
      publishedAt: '2026-05-13T13:32:34.013Z',
      locale: 'en',
      documentId: 'u0k6rizq4m55gnof48vljx51',
    },
    {
      id: 4276,
      slug: 'why-uk-users-switch-from-vpn-to-proxies',
      createdAt: '2025-07-30T06:11:57.511Z',
      updatedAt: '2026-06-09T13:50:42.582Z',
      publishedAt: '2026-06-09T13:50:43.641Z',
      locale: 'en',
      documentId: 'fei8bkrw6al6tmni23sizxk1',
    },
    {
      id: 3398,
      slug: 'scrape-tiktok',
      createdAt: '2025-07-31T10:28:37.004Z',
      updatedAt: '2026-01-30T13:35:59.941Z',
      publishedAt: '2026-01-30T13:36:01.735Z',
      locale: 'en',
      documentId: 'rc3i9lk6g72851bnwognwik4',
    },
    {
      id: 3962,
      slug: 'cloudflare-errors-1006-1007-1008',
      createdAt: '2025-08-04T10:07:29.385Z',
      updatedAt: '2026-04-30T11:48:12.218Z',
      publishedAt: '2026-04-30T11:48:13.064Z',
      locale: 'en',
      documentId: 'qkyn5rd9ho501tdae1i4pmf6',
    },
    {
      id: 3181,
      slug: 'how-to-set-up-mcp-server',
      createdAt: '2025-08-04T11:12:31.338Z',
      updatedAt: '2025-12-23T11:50:54.884Z',
      publishedAt: '2025-12-23T11:50:55.586Z',
      locale: 'en',
      documentId: 'k0czah6o4pr7pax6gdzqs1ny',
    },
    {
      id: 3040,
      slug: 'smartproxy-vs-decodo',
      createdAt: '2025-08-04T11:46:16.559Z',
      updatedAt: '2025-11-17T07:26:15.194Z',
      publishedAt: '2025-11-17T07:26:17.535Z',
      locale: 'en',
      documentId: 'y17k8evr6hz3uihfhbcylz49',
    },
    {
      id: 3547,
      slug: 'what-is-janitor-ai',
      createdAt: '2025-08-05T12:54:03.804Z',
      updatedAt: '2026-03-03T13:55:52.568Z',
      publishedAt: '2026-03-03T13:55:53.763Z',
      locale: 'en',
      documentId: 'kkzxxs3h51ikvu28y3oe9f17',
    },
    {
      id: 3772,
      slug: 'how-to-bypass-google-captcha',
      createdAt: '2025-08-11T07:32:04.267Z',
      updatedAt: '2026-04-09T12:41:40.626Z',
      publishedAt: '2026-04-09T12:41:41.941Z',
      locale: 'en',
      documentId: 'y3dpzv3w24vyhf5rx1cfc95e',
    },
    {
      id: 4159,
      slug: 'error-1020-ultimate-guide',
      createdAt: '2025-08-12T10:55:08.468Z',
      updatedAt: '2026-05-26T09:58:34.362Z',
      publishedAt: '2026-05-26T09:58:35.357Z',
      locale: 'en',
      documentId: 'zp4dumzd997gto4obkf8ch3m',
    },
    {
      id: 2766,
      slug: 'how-to-scrape-website-to-markdown',
      createdAt: '2025-08-13T11:04:44.265Z',
      updatedAt: '2025-08-14T07:58:59.032Z',
      publishedAt: '2025-08-14T07:59:00.152Z',
      locale: 'en',
      documentId: 'jhsbzxf8xjqgs88f4bc4tpec',
    },
    {
      id: 3373,
      slug: 'top-10-mcp-for-ai-workflows',
      createdAt: '2025-08-13T10:00:21.783Z',
      updatedAt: '2026-01-30T12:38:58.693Z',
      publishedAt: '2026-01-30T12:39:01.063Z',
      locale: 'en',
      documentId: 'ohnuhdh59bll650h1njfhiud',
    },
    {
      id: 3296,
      slug: 'how-to-bypass-ai-labyrinth',
      createdAt: '2025-08-14T08:07:58.628Z',
      updatedAt: '2026-01-16T08:28:49.306Z',
      publishedAt: '2026-01-16T08:28:49.970Z',
      locale: 'en',
      documentId: 'fjt0nqt7qri5qm3cvwq4wc9e',
    },
    {
      id: 3375,
      slug: 'how-to-run-python-code-in-terminal',
      createdAt: '2025-08-19T13:37:07.337Z',
      updatedAt: '2026-01-30T12:42:40.951Z',
      publishedAt: '2026-01-30T12:42:42.544Z',
      locale: 'en',
      documentId: 'ao6y81w9365x77zpyskvcc61',
    },
    {
      id: 3064,
      slug: 'how-to-save-your-scraped-data',
      createdAt: '2025-08-28T08:50:53.007Z',
      updatedAt: '2025-11-20T12:04:19.148Z',
      publishedAt: '2025-11-20T12:04:19.994Z',
      locale: 'en',
      documentId: 'uw1pougv7f5t7mojm2tfiv35',
    },
    {
      id: 4085,
      slug: 'claude-web-scraping',
      createdAt: '2025-08-29T12:15:44.454Z',
      updatedAt: '2026-05-18T09:58:50.837Z',
      publishedAt: '2026-05-18T09:58:53.352Z',
      locale: 'en',
      documentId: 'ciuathlb72kmdzbbkx42b1y7',
    },
    {
      id: 3287,
      slug: 'most-scraped-websites-2025',
      createdAt: '2025-09-04T11:51:37.217Z',
      updatedAt: '2026-01-15T11:46:00.943Z',
      publishedAt: '2026-01-15T11:46:01.683Z',
      locale: 'en',
      documentId: 'aph3jkh6i27l3qyg0ms0ab4n',
    },
    {
      id: 2847,
      slug: 'data-mining-vs-web-scraping',
      createdAt: '2025-09-12T08:12:52.772Z',
      updatedAt: '2025-09-12T09:13:53.211Z',
      publishedAt: '2025-09-12T09:13:53.856Z',
      locale: 'en',
      documentId: 'gvkqg69f68pb38ozkbdh2o9m',
    },
    {
      id: 4357,
      slug: 'scrape-indeed-guide',
      createdAt: '2025-09-12T09:56:49.834Z',
      updatedAt: '2026-06-16T06:48:27.494Z',
      publishedAt: '2026-06-16T06:48:28.656Z',
      locale: 'en',
      documentId: 'avc7mcmksnkfk77h7ug4ad6f',
    },
    {
      id: 4292,
      slug: 'error-1009',
      createdAt: '2025-09-12T09:26:12.542Z',
      updatedAt: '2026-06-10T10:44:08.899Z',
      publishedAt: '2026-06-10T10:44:09.816Z',
      locale: 'en',
      documentId: 'ejh6t5qduwrvy0f0u6asosaw',
    },
    {
      id: 2870,
      slug: 'how-to-build-crybaby-bot',
      createdAt: '2025-09-16T10:16:34.303Z',
      updatedAt: '2025-09-16T10:26:44.593Z',
      publishedAt: '2025-09-16T10:26:45.092Z',
      locale: 'en',
      documentId: 'r13loi0i5nsxsw1i4ea1e4wa',
    },
    {
      id: 3728,
      slug: 'n8n-web-scraping-automation',
      createdAt: '2025-09-19T09:44:16.770Z',
      updatedAt: '2026-03-31T07:48:53.325Z',
      publishedAt: '2026-03-31T07:48:54.934Z',
      locale: 'en',
      documentId: 'o1ydxrihxjk6k29tdbphwvou',
    },
    {
      id: 3295,
      slug: 'how-to-build-an-llm',
      createdAt: '2025-09-23T09:32:54.138Z',
      updatedAt: '2026-01-16T08:26:34.173Z',
      publishedAt: '2026-01-16T08:26:34.738Z',
      locale: 'en',
      documentId: 'odjd095armkzsb9g1shn83i4',
    },
    {
      id: 2957,
      slug: 'eu-chat-control-for-businesses',
      createdAt: '2025-09-24T09:35:26.860Z',
      updatedAt: '2025-10-16T08:46:45.446Z',
      publishedAt: '2025-10-16T08:46:46.230Z',
      locale: 'en',
      documentId: 'g26a9wg1va123fdjatfc8yo8',
    },
    {
      id: 4158,
      slug: 'youtube-error-400',
      createdAt: '2025-09-26T06:52:08.893Z',
      updatedAt: '2026-05-26T09:57:19.016Z',
      publishedAt: '2026-05-26T09:57:20.509Z',
      locale: 'en',
      documentId: 'yagopqo358x0oe2xz91mofq6',
    },
    {
      id: 3842,
      slug: 'web-scraping-market-research',
      createdAt: '2025-09-26T09:25:52.498Z',
      updatedAt: '2026-04-17T06:36:24.459Z',
      publishedAt: '2026-04-17T06:36:25.856Z',
      locale: 'en',
      documentId: 'cpmia58rfxzbbzemcozmoa85',
    },
    {
      id: 4051,
      slug: 'ai-agent-orchestration-n8n-decodo-mcp',
      createdAt: '2025-09-30T08:29:04.032Z',
      updatedAt: '2026-05-08T09:21:36.215Z',
      publishedAt: '2026-05-08T09:21:37.626Z',
      locale: 'en',
      documentId: 'c11ji4n5p6kvjvviyaor1hl5',
    },
    {
      id: 2906,
      slug: 'how-to-train-gpt',
      createdAt: '2025-10-03T09:50:05.927Z',
      updatedAt: '2025-10-03T10:23:59.569Z',
      publishedAt: '2025-10-03T10:24:00.403Z',
      locale: 'en',
      documentId: 'unxlld7hvcc5tbiohq6ilft7',
    },
    {
      id: 3803,
      slug: 'error-code-1010',
      createdAt: '2025-10-03T10:52:00.031Z',
      updatedAt: '2026-04-14T07:04:27.804Z',
      publishedAt: '2026-04-14T07:04:28.606Z',
      locale: 'en',
      documentId: 'ov6719al6zzrmebecuatdom3',
    },
    {
      id: 2996,
      slug: 'youtube-error-429',
      createdAt: '2025-10-07T11:45:53.875Z',
      updatedAt: '2025-10-27T09:19:18.668Z',
      publishedAt: '2025-10-27T09:19:19.699Z',
      locale: 'en',
      documentId: 'uslfbigfcxhx0tfkk56zpt3c',
    },
    {
      id: 3595,
      slug: 'how-to-scrape-soundcloud-for-ai',
      createdAt: '2025-10-08T09:56:18.244Z',
      updatedAt: '2026-03-17T06:30:58.841Z',
      publishedAt: '2026-03-17T06:31:00.202Z',
      locale: 'en',
      documentId: 'jhqgt47kxief8mh1wk4j5pqt',
    },
    {
      id: 3511,
      slug: 'scrape-yahoo-finance',
      createdAt: '2025-10-09T08:37:52.107Z',
      updatedAt: '2026-02-25T09:35:06.472Z',
      publishedAt: '2026-02-25T09:35:07.520Z',
      locale: 'en',
      documentId: 'x49cqugfwcv16msvqstuddxx',
    },
    {
      id: 4264,
      slug: 'is-web-scraping-legal',
      createdAt: '2025-10-15T13:31:28.105Z',
      updatedAt: '2026-06-09T13:03:43.415Z',
      publishedAt: '2026-06-09T13:03:44.137Z',
      locale: 'en',
      documentId: 'ls3kv509ecyefoprlr1vq463',
    },
    {
      id: 4272,
      slug: 'youtube-error-403',
      createdAt: '2025-10-16T10:01:51.639Z',
      updatedAt: '2026-06-09T13:28:06.341Z',
      publishedAt: '2026-06-09T13:28:07.102Z',
      locale: 'en',
      documentId: 'f44bpy2zmz58wzqx91j42npu',
    },
    {
      id: 3412,
      slug: 'end-to-end-ai-workflows-langchain-web-scraping-api',
      createdAt: '2025-10-22T10:20:27.173Z',
      updatedAt: '2026-02-04T06:51:18.063Z',
      publishedAt: '2026-02-04T06:51:20.060Z',
      locale: 'en',
      documentId: 'vpogfeaptot5q50f1bd4l6ln',
    },
    {
      id: 4263,
      slug: 'google-removes-num-100-parameter',
      createdAt: '2025-10-23T12:54:52.166Z',
      updatedAt: '2026-06-09T13:01:38.321Z',
      publishedAt: '2026-06-09T13:01:39.562Z',
      locale: 'en',
      documentId: 'y4jmdytk7n1w4xme0j0owx2f',
    },
    {
      id: 3517,
      slug: 'build-production-rag-llamaindex-web-scraping',
      createdAt: '2025-10-24T10:20:43.220Z',
      updatedAt: '2026-02-25T14:41:20.614Z',
      publishedAt: '2026-02-25T14:41:21.746Z',
      locale: 'en',
      documentId: 'i9ogrgeln08y7k7f9akjj1ex',
    },
    {
      id: 4370,
      slug: 'how-to-scrape-google-trends',
      createdAt: '2025-10-27T09:29:33.010Z',
      updatedAt: '2026-06-16T08:27:55.805Z',
      publishedAt: '2026-06-16T08:27:57.128Z',
      locale: 'en',
      documentId: 'fgwf9s0fokmpejgymlbaad38',
    },
    {
      id: 3594,
      slug: 'scrape-craigslist',
      createdAt: '2025-10-27T14:05:53.962Z',
      updatedAt: '2026-03-17T06:23:17.086Z',
      publishedAt: '2026-03-17T06:23:18.285Z',
      locale: 'en',
      documentId: 'qs44u77x6vyqv3l9v0vmpwik',
    },
    {
      id: 4100,
      slug: 'web-scraping-pagination',
      createdAt: '2025-10-28T08:40:59.454Z',
      updatedAt: '2026-05-18T10:22:53.947Z',
      publishedAt: '2026-05-18T10:22:55.818Z',
      locale: 'en',
      documentId: 'b7x4xzayulpcyo8ctcf5wywy',
    },
    {
      id: 3024,
      slug: 'ip-replacement-option',
      createdAt: '2025-10-31T10:50:16.869Z',
      updatedAt: '2025-11-07T18:22:40.226Z',
      publishedAt: '2025-11-07T18:22:40.945Z',
      locale: 'en',
      documentId: 'sxa9mzgfxk6iz386xj2en7e0',
    },
    {
      id: 4253,
      slug: 'web-scrape-table-python',
      createdAt: '2025-11-10T12:46:24.087Z',
      updatedAt: '2026-06-09T11:54:56.270Z',
      publishedAt: '2026-06-09T11:54:57.405Z',
      locale: 'en',
      documentId: 'ka9iwujzf65yyg0b1pgp72bp',
    },
    {
      id: 3955,
      slug: 'black-friday-dynamic-pricing-strategies',
      createdAt: '2025-11-13T07:14:36.131Z',
      updatedAt: '2026-04-30T11:40:44.577Z',
      publishedAt: '2026-04-30T11:40:45.475Z',
      locale: 'en',
      documentId: 'mj79pmr0spuo49ty38r3hd2v',
    },
    {
      id: 3112,
      slug: 'airbnb-web-scraping',
      createdAt: '2025-11-17T09:02:12.916Z',
      updatedAt: '2025-12-10T10:39:43.407Z',
      publishedAt: '2025-12-10T10:39:44.291Z',
      locale: 'en',
      documentId: 'my3ns1vel3imdc48ufl6gq80',
    },
    {
      id: 3957,
      slug: 'cloudflare-outage',
      createdAt: '2025-11-18T12:40:10.341Z',
      updatedAt: '2026-04-30T11:43:28.692Z',
      publishedAt: '2026-04-30T11:43:29.561Z',
      locale: 'en',
      documentId: 'ukjlo7nz7i6vy0n5r1oinijz',
    },
    {
      id: 3830,
      slug: 'uk-ticket-resale-ban',
      createdAt: '2025-11-18T14:55:35.994Z',
      updatedAt: '2026-04-16T11:49:32.520Z',
      publishedAt: '2026-04-16T11:49:33.816Z',
      locale: 'en',
      documentId: 'flmv524tqa3fyb6za4yq7k6g',
    },
    {
      id: 4283,
      slug: 'scrape-nasdaq',
      createdAt: '2025-11-21T07:49:33.244Z',
      updatedAt: '2026-06-10T07:00:34.404Z',
      publishedAt: '2026-06-10T07:00:35.606Z',
      locale: 'en',
      documentId: 'oq922e4oic2kkg9piyd063bj',
    },
    {
      id: 3081,
      slug: 'web-scraping-java',
      createdAt: '2025-11-26T10:22:55.903Z',
      updatedAt: '2025-11-26T11:34:32.711Z',
      publishedAt: '2025-11-26T11:34:33.737Z',
      locale: 'en',
      documentId: 'ok3n504c0phyz5lgzojv1xl5',
    },
    {
      id: 4250,
      slug: 'scraping-with-curl',
      createdAt: '2025-12-02T11:21:49.255Z',
      updatedAt: '2026-06-09T10:42:44.252Z',
      publishedAt: '2026-06-09T10:42:45.741Z',
      locale: 'en',
      documentId: 'fahqdqxaxj81netkmbao2h2z',
    },
    {
      id: 3125,
      slug: 'post-black-friday-us-shopping',
      createdAt: '2025-12-05T11:46:34.167Z',
      updatedAt: '2025-12-15T07:52:17.148Z',
      publishedAt: '2025-12-15T07:52:17.795Z',
      locale: 'en',
      documentId: 'idkectvthrzrt3bm54f89c1p',
    },
    {
      id: 3384,
      slug: 'csharp-web-scraping-guide',
      createdAt: '2025-12-05T12:28:02.903Z',
      updatedAt: '2026-01-30T13:05:04.788Z',
      publishedAt: '2026-01-30T13:05:06.666Z',
      locale: 'en',
      documentId: 'sm0wer4o5y2sdevg2n8pbgir',
    },
    {
      id: 3177,
      slug: 'real-estate-scraping',
      createdAt: '2025-12-10T08:08:42.902Z',
      updatedAt: '2025-12-22T13:28:38.825Z',
      publishedAt: '2025-12-22T13:28:39.470Z',
      locale: 'en',
      documentId: 'qu0nchtbgfr0ajr0fdq7m9ft',
    },
    {
      id: 3121,
      slug: 'web-scraping-with-ruby',
      createdAt: '2025-12-12T07:46:04.968Z',
      updatedAt: '2025-12-12T11:01:28.780Z',
      publishedAt: '2025-12-12T11:01:30.048Z',
      locale: 'en',
      documentId: 'mr3mxyio5dr59tjvqekkqvo0',
    },
    {
      id: 3411,
      slug: 'what-is-ai-scraping',
      createdAt: '2025-12-15T13:22:57.494Z',
      updatedAt: '2026-02-04T06:49:10.761Z',
      publishedAt: '2026-02-04T06:49:12.434Z',
      locale: 'en',
      documentId: 'em5m6v6vc6u8ikgv112zbxpq',
    },
    {
      id: 4338,
      slug: 'scraping-wikipedia',
      createdAt: '2025-12-16T13:25:15.713Z',
      updatedAt: '2026-06-11T12:45:10.564Z',
      publishedAt: '2026-06-11T12:45:12.112Z',
      locale: 'en',
      documentId: 'njvto8hyus28mtemh49efjwx',
    },
    {
      id: 3420,
      slug: 'how-to-scrape-etsy',
      createdAt: '2025-12-19T14:28:59.897Z',
      updatedAt: '2026-02-12T08:59:34.094Z',
      publishedAt: '2026-02-12T08:59:35.682Z',
      locale: 'en',
      documentId: 'wtk0n7cev92k9psz0hyfrbp1',
    },
    {
      id: 3937,
      slug: 'ai-web-scraping-python',
      createdAt: '2025-12-23T11:51:43.493Z',
      updatedAt: '2026-04-30T11:14:43.109Z',
      publishedAt: '2026-04-30T11:14:44.138Z',
      locale: 'en',
      documentId: 'ivjuapu845hg7341xn8imdcw',
    },
    {
      id: 4099,
      slug: 'find-all-urls-on-a-domain',
      createdAt: '2026-02-09T13:43:47.065Z',
      updatedAt: '2026-05-18T10:22:39.978Z',
      publishedAt: '2026-05-18T10:22:42.351Z',
      locale: 'en',
      documentId: 'nd7c2tsv35bvmf2svrtld6a7',
    },
    {
      id: 4333,
      slug: 'what-is-a-proxy-server',
      createdAt: '2026-02-12T11:07:54.380Z',
      updatedAt: '2026-06-11T11:36:47.849Z',
      publishedAt: '2026-06-11T11:36:49.479Z',
      locale: 'en',
      documentId: 'dtgf50rdyzij60gnlnk40f08',
    },
    {
      id: 4280,
      slug: 'web-scraping-at-scale',
      createdAt: '2026-02-18T14:05:12.334Z',
      updatedAt: '2026-06-10T06:48:39.961Z',
      publishedAt: '2026-06-10T06:48:42.084Z',
      locale: 'en',
      documentId: 'o3stglswz6rtxmrtjetkgtp0',
    },
    {
      id: 3969,
      slug: 'decodo-openclaw-integration',
      createdAt: '2026-02-19T12:32:30.683Z',
      updatedAt: '2026-04-30T12:08:38.319Z',
      publishedAt: '2026-04-30T12:08:39.472Z',
      locale: 'en',
      documentId: 'afji5frae9o6oce8zgmfb8rw',
    },
    {
      id: 3596,
      slug: 'how-do-apis-work',
      createdAt: '2026-02-20T10:50:40.655Z',
      updatedAt: '2026-03-17T06:32:40.606Z',
      publishedAt: '2026-03-17T06:32:41.371Z',
      locale: 'en',
      documentId: 'h3ifbqkv87fpuelowjlw0itz',
    },
    {
      id: 4330,
      slug: 'socks5-proxy-setup',
      createdAt: '2026-02-26T12:56:46.794Z',
      updatedAt: '2026-06-11T11:10:30.060Z',
      publishedAt: '2026-06-11T11:10:30.725Z',
      locale: 'en',
      documentId: 'q4ueidh1rs2k45knnwlhbx1u',
    },
    {
      id: 4260,
      slug: 'scrapy-web-scraping',
      createdAt: '2026-03-02T09:23:33.238Z',
      updatedAt: '2026-06-09T12:47:37.682Z',
      publishedAt: '2026-06-09T12:47:38.678Z',
      locale: 'en',
      documentId: 'vjpbp960i69hpknxhzimsj9h',
    },
    {
      id: 4318,
      slug: 'web-crawler-python',
      createdAt: '2026-03-02T09:55:04.015Z',
      updatedAt: '2026-06-11T07:53:46.714Z',
      publishedAt: '2026-06-11T07:53:48.005Z',
      locale: 'en',
      documentId: 'ihktnthq2yn625ist03cppo5',
    },
    {
      id: 3549,
      slug: 'httpx-vs-requests-vs-aiohttp',
      createdAt: '2026-03-03T06:57:22.064Z',
      updatedAt: '2026-03-03T14:29:38.790Z',
      publishedAt: '2026-03-03T14:29:44.058Z',
      locale: 'en',
      documentId: 'ydfe4ae4sxvoqjvutmh8zsrh',
    },
    {
      id: 4232,
      slug: 'csharp-httpclient-proxy',
      createdAt: '2026-03-03T13:03:10.847Z',
      updatedAt: '2026-06-05T11:31:01.442Z',
      publishedAt: '2026-06-05T11:31:03.742Z',
      locale: 'en',
      documentId: 'v6h36lhennnrpp44sx2md9fn',
    },
    {
      id: 3584,
      slug: 'pokemon-card-bot',
      createdAt: '2026-03-13T09:02:45.118Z',
      updatedAt: '2026-03-13T09:26:31.488Z',
      publishedAt: '2026-03-13T09:26:32.207Z',
      locale: 'en',
      documentId: 'ldgccvqo0kkoccf6mznmg9bt',
    },
    {
      id: 4211,
      slug: 'error-1005',
      createdAt: '2026-03-16T13:27:09.315Z',
      updatedAt: '2026-06-05T07:46:04.077Z',
      publishedAt: '2026-06-05T07:46:05.274Z',
      locale: 'en',
      documentId: 'lqft6jwz63x1ns8sxcprr7sx',
    },
    {
      id: 4057,
      slug: 'wget-proxy',
      createdAt: '2026-03-17T12:51:53.340Z',
      updatedAt: '2026-05-11T07:50:22.663Z',
      publishedAt: '2026-05-11T07:50:23.984Z',
      locale: 'en',
      documentId: 'm91oxv18w6q7y9fnatrivgna',
    },
    {
      id: 3612,
      slug: 'location-based-pricing',
      createdAt: '2026-03-19T10:09:04.715Z',
      updatedAt: '2026-03-19T10:12:51.727Z',
      publishedAt: '2026-03-19T10:12:52.485Z',
      locale: 'en',
      documentId: 'xvwe54nmqi719f6hv7csmhpo',
    },
    {
      id: 3952,
      slug: 'best-bing-rank-trackers',
      createdAt: '2026-03-19T11:13:07.185Z',
      updatedAt: '2026-04-30T11:36:51.574Z',
      publishedAt: '2026-04-30T11:36:52.775Z',
      locale: 'en',
      documentId: 's49oh57ll6iei5gusmyt92m3',
    },
    {
      id: 4215,
      slug: 'proxy-telegram',
      createdAt: '2026-03-19T10:51:45.978Z',
      updatedAt: '2026-06-05T08:03:16.780Z',
      publishedAt: '2026-06-05T08:03:18.385Z',
      locale: 'en',
      documentId: 'lewpj62wrysp99a40midegqq',
    },
    {
      id: 4267,
      slug: 'best-rank-tracker-api',
      createdAt: '2026-03-20T09:19:07.589Z',
      updatedAt: '2026-06-09T13:07:19.777Z',
      publishedAt: '2026-06-09T13:07:20.985Z',
      locale: 'en',
      documentId: 'emw3l3iund33h4s7eomm6ye1',
    },
    {
      id: 4056,
      slug: 'minimum-advertised-price-monitoring',
      createdAt: '2026-03-19T08:09:17.222Z',
      updatedAt: '2026-05-11T07:46:42.910Z',
      publishedAt: '2026-05-11T07:46:43.720Z',
      locale: 'en',
      documentId: 'g5xgoiveexcpbse7bvtw8z9v',
    },
    {
      id: 3839,
      slug: 'decodo-new-ceo-vaidotas-juknys',
      createdAt: '2026-03-25T05:28:45.532Z',
      updatedAt: '2026-04-17T06:28:25.310Z',
      publishedAt: '2026-04-17T06:28:25.950Z',
      locale: 'en',
      documentId: 'w5onbu0f2kvx06h2oanz05fh',
    },
    {
      id: 3636,
      slug: 'php-web-scraping',
      createdAt: '2026-03-26T11:19:20.901Z',
      updatedAt: '2026-03-26T13:04:52.577Z',
      publishedAt: '2026-03-26T13:04:53.816Z',
      locale: 'en',
      documentId: 'toz3eubwov72bajyw2ctopxk',
    },
    {
      id: 3953,
      slug: 'best-python-http-clients',
      createdAt: '2026-03-26T10:46:45.193Z',
      updatedAt: '2026-04-30T11:37:59.865Z',
      publishedAt: '2026-04-30T11:38:01.369Z',
      locale: 'en',
      documentId: 'hfmunju7q3pomo4i3gbfga4v',
    },
    {
      id: 4320,
      slug: 'playwright-vs-selenium',
      createdAt: '2026-03-27T13:52:44.617Z',
      updatedAt: '2026-06-11T07:57:39.591Z',
      publishedAt: '2026-06-11T07:57:40.335Z',
      locale: 'en',
      documentId: 'if0yzzdqhimzlyk3ze3vz24p',
    },
    {
      id: 4331,
      slug: 'scrape-google-flights',
      createdAt: '2026-03-27T09:31:17.207Z',
      updatedAt: '2026-06-11T11:28:28.431Z',
      publishedAt: '2026-06-11T11:28:29.563Z',
      locale: 'en',
      documentId: 'xqp6t33ge4z990c4eqm5nmpf',
    },
    {
      id: 3844,
      slug: 'how-to-web-scrape-ebay',
      createdAt: '2026-03-30T07:49:07.557Z',
      updatedAt: '2026-04-17T06:46:36.888Z',
      publishedAt: '2026-04-17T06:46:38.433Z',
      locale: 'en',
      documentId: 't2ib0m0psd8jclb7e8ij8ab2',
    },
    {
      id: 4373,
      slug: 'web-scraping-guide-with-camoufox',
      createdAt: '2026-03-30T12:36:58.842Z',
      updatedAt: '2026-06-16T10:32:03.381Z',
      publishedAt: '2026-06-16T10:32:04.818Z',
      locale: 'en',
      documentId: 'abb4tzshfqespc42og0f3rut',
    },
    {
      id: 4284,
      slug: 'schedule-web-scraping-tasks',
      createdAt: '2026-04-01T09:58:40.271Z',
      updatedAt: '2026-06-10T07:36:30.665Z',
      publishedAt: '2026-06-10T07:36:31.885Z',
      locale: 'en',
      documentId: 'qzdvk8f161u93s6s2d6jmkf6',
    },
    {
      id: 4246,
      slug: 'nodriver',
      createdAt: '2026-04-01T11:24:16.595Z',
      updatedAt: '2026-06-09T10:30:24.492Z',
      publishedAt: '2026-06-09T10:30:25.672Z',
      locale: 'en',
      documentId: 'z5uchz1f7bh7yjdy8t9zbxzr',
    },
    {
      id: 3762,
      slug: 'scrape-google-ai-mode',
      createdAt: '2026-04-03T08:54:35.877Z',
      updatedAt: '2026-04-03T11:39:35.193Z',
      publishedAt: '2026-04-03T11:39:36.579Z',
      locale: 'en',
      documentId: 'x9an6h7wn739gmh9b0975jz3',
    },
    {
      id: 3806,
      slug: 'how-to-bypass-creepjs',
      createdAt: '2026-04-07T08:24:22.193Z',
      updatedAt: '2026-04-14T07:09:41.486Z',
      publishedAt: '2026-04-14T07:09:42.583Z',
      locale: 'en',
      documentId: 'yrmqk3qbghh2zrjyvnnd1mvf',
    },
    {
      id: 4266,
      slug: 'anthropic-openclaw-claude-subscription-ban-guide',
      createdAt: '2026-04-09T05:34:43.004Z',
      updatedAt: '2026-06-09T13:06:04.327Z',
      publishedAt: '2026-06-09T13:06:05.511Z',
      locale: 'en',
      documentId: 'whlyfgsibpxmztevfs0s2rj3',
    },
    {
      id: 4368,
      slug: 'dynamic-pricing-ban-ecommerce-impact',
      createdAt: '2026-04-10T06:48:34.290Z',
      updatedAt: '2026-06-16T07:06:45.600Z',
      publishedAt: '2026-06-16T07:06:46.368Z',
      locale: 'en',
      documentId: 'lgdhayjw434oyc44yk4tox5c',
    },
    {
      id: 3821,
      slug: 'how-to-store-data-in-sqlite',
      createdAt: '2026-04-10T07:50:55.817Z',
      updatedAt: '2026-04-15T12:14:11.142Z',
      publishedAt: '2026-04-15T12:14:14.721Z',
      locale: 'en',
      documentId: 'tbmno09l87k63zvg22lb8mr5',
    },
    {
      id: 4314,
      slug: 'characteristics-of-rest-api',
      createdAt: '2026-04-13T06:23:56.262Z',
      updatedAt: '2026-06-11T06:41:03.166Z',
      publishedAt: '2026-06-11T06:41:05.236Z',
      locale: 'en',
      documentId: 't4dl5v5kb39gx099zpq76v4e',
    },
    {
      id: 4251,
      slug: 'scrape-glassdoor',
      createdAt: '2026-04-10T10:19:54.037Z',
      updatedAt: '2026-06-09T10:53:23.009Z',
      publishedAt: '2026-06-09T10:53:24.772Z',
      locale: 'en',
      documentId: 't2hlcasr8qdnss7n2jpe552e',
    },
    {
      id: 3865,
      slug: 'no-code-web-scraping-playwright-mcp',
      createdAt: '2026-04-14T06:17:20.154Z',
      updatedAt: '2026-04-21T12:52:35.193Z',
      publishedAt: '2026-04-21T12:52:37.298Z',
      locale: 'en',
      documentId: 'wykqebhu5zto7o2ip0pps1ng',
    },
    {
      id: 4294,
      slug: 'rust-web-scraping',
      createdAt: '2026-04-15T06:42:49.901Z',
      updatedAt: '2026-06-10T10:59:23.580Z',
      publishedAt: '2026-06-10T10:59:24.645Z',
      locale: 'en',
      documentId: 'gw3mfo849cvows87xl05xcmu',
    },
    {
      id: 4234,
      slug: 'how-to-scrape-all-text-from-a-website',
      createdAt: '2026-04-15T07:59:05.514Z',
      updatedAt: '2026-06-05T11:58:17.582Z',
      publishedAt: '2026-06-05T11:58:19.290Z',
      locale: 'en',
      documentId: 'jmit15mbtkd32rtulticvcr1',
    },
    {
      id: 4285,
      slug: 'crawl4ai-tutorial',
      createdAt: '2026-04-14T10:32:26.938Z',
      updatedAt: '2026-06-10T07:38:12.350Z',
      publishedAt: '2026-06-10T07:38:14.465Z',
      locale: 'en',
      documentId: 'cug3zgpacyns1mm4oevq78dp',
    },
    {
      id: 4148,
      slug: 'browseruse',
      createdAt: '2026-04-17T10:05:54.358Z',
      updatedAt: '2026-05-26T05:56:06.130Z',
      publishedAt: '2026-05-26T05:56:07.322Z',
      locale: 'en',
      documentId: 'e9n86tcs97ih1jips8ftxsy3',
    },
    {
      id: 4258,
      slug: 'scrape-emails-from-website',
      createdAt: '2026-04-20T06:13:36.368Z',
      updatedAt: '2026-06-09T12:17:33.228Z',
      publishedAt: '2026-06-09T12:17:34.508Z',
      locale: 'en',
      documentId: 'zgmwnjnqium93q5glxg7l4o9',
    },
    {
      id: 3949,
      slug: 'b2b-toolstack-cost',
      createdAt: '2026-04-21T06:40:56.023Z',
      updatedAt: '2026-04-30T11:32:23.180Z',
      publishedAt: '2026-04-30T11:32:26.272Z',
      locale: 'en',
      documentId: 'kjvf0f8t6ixx2hlf30r0o1nq',
    },
    {
      id: 4279,
      slug: 'how-to-bypass-perimeterx',
      createdAt: '2026-04-21T08:31:06.973Z',
      updatedAt: '2026-06-10T06:42:15.692Z',
      publishedAt: '2026-06-10T06:42:16.834Z',
      locale: 'en',
      documentId: 'qmwqb4sou7xmu86n54xhg5up',
    },
    {
      id: 3886,
      slug: 'axios-post-headers',
      createdAt: '2026-04-22T05:53:12.357Z',
      updatedAt: '2026-04-22T08:48:29.670Z',
      publishedAt: '2026-04-22T08:48:30.906Z',
      locale: 'en',
      documentId: 'g7rose90i8cfgpr4nv13l1p6',
    },
    {
      id: 3896,
      slug: 'curl-in-javascript',
      createdAt: '2026-04-22T11:18:37.873Z',
      updatedAt: '2026-04-22T15:29:44.566Z',
      publishedAt: '2026-04-22T15:29:46.460Z',
      locale: 'en',
      documentId: 'f4jx0eiwwyxa9vz2vla49r12',
    },
    {
      id: 4058,
      slug: 'web-scraping-shopify',
      createdAt: '2026-04-22T09:02:41.767Z',
      updatedAt: '2026-05-11T11:13:36.405Z',
      publishedAt: '2026-05-11T11:13:38.343Z',
      locale: 'en',
      documentId: 'd99d1d3t5x19xaxwpdpwrdso',
    },
    {
      id: 3899,
      slug: 'playwright-wait-for-page-to-load',
      createdAt: '2026-04-23T06:53:49.617Z',
      updatedAt: '2026-04-23T07:57:41.530Z',
      publishedAt: '2026-04-23T07:57:42.304Z',
      locale: 'en',
      documentId: 'x228lbnvvdukueig84gi9gsm',
    },
    {
      id: 3900,
      slug: 'undetected-chromedriver',
      createdAt: '2026-04-16T06:15:07.099Z',
      updatedAt: '2026-04-23T08:06:04.416Z',
      publishedAt: '2026-04-23T08:06:05.144Z',
      locale: 'en',
      documentId: 'ajkulhkforh8yaxcphl02agt',
    },
    {
      id: 4147,
      slug: 'autogpt-integration-guide',
      createdAt: '2026-04-23T06:00:53.474Z',
      updatedAt: '2026-05-26T05:54:44.137Z',
      publishedAt: '2026-05-26T05:54:48.926Z',
      locale: 'en',
      documentId: 'aubz8q7qswxnt2nlgwkjwoey',
    },
    {
      id: 4299,
      slug: 'web-scraping-with-linux',
      createdAt: '2026-04-22T12:59:52.289Z',
      updatedAt: '2026-06-10T11:37:23.901Z',
      publishedAt: '2026-06-10T11:37:25.360Z',
      locale: 'en',
      documentId: 'euvlxp7ighhd4d4icesoo83q',
    },
    {
      id: 3928,
      slug: 'web-scraping-without-getting-blocked',
      createdAt: '2026-04-23T11:48:42.644Z',
      updatedAt: '2026-04-30T08:18:24.809Z',
      publishedAt: '2026-04-30T08:18:26.095Z',
      locale: 'en',
      documentId: 'vlnvarejbcilnchmwehzhs68',
    },
    {
      id: 4290,
      slug: 'cloudflare-scraper',
      createdAt: '2026-04-23T12:16:02.377Z',
      updatedAt: '2026-06-10T10:37:29.936Z',
      publishedAt: '2026-06-10T10:37:30.854Z',
      locale: 'en',
      documentId: 'u9m1fgi5s0cdxyoeu3zf74re',
    },
    {
      id: 4146,
      slug: 'apache-nutch',
      createdAt: '2026-04-24T10:25:04.053Z',
      updatedAt: '2026-05-26T05:52:32.977Z',
      publishedAt: '2026-05-26T05:52:34.017Z',
      locale: 'en',
      documentId: 'ozz4aexe19h40hg4eedynkxe',
    },
    {
      id: 3913,
      slug: 'puppeteer-vs-playwright',
      createdAt: '2026-04-24T12:16:28.616Z',
      updatedAt: '2026-04-24T13:14:31.040Z',
      publishedAt: '2026-04-24T13:14:31.976Z',
      locale: 'en',
      documentId: 't93dblgf1v0px2lduycgbszj',
    },
    {
      id: 3914,
      slug: 'fix-sslerror-python-requests',
      createdAt: '2026-04-24T13:07:35.402Z',
      updatedAt: '2026-04-24T13:25:02.916Z',
      publishedAt: '2026-04-24T13:25:03.619Z',
      locale: 'en',
      documentId: 'v6kpbma970hg00hmhamkgct8',
    },
    {
      id: 3977,
      slug: 'beautiful-soup-wait-for-page-to-load',
      createdAt: '2026-04-27T12:39:03.713Z',
      updatedAt: '2026-04-30T12:38:00.998Z',
      publishedAt: '2026-04-30T12:38:02.335Z',
      locale: 'en',
      documentId: 'n44ql6zvkgpbz33xfojv4tiw',
    },
    {
      id: 3924,
      slug: 'jsoup-parsing-html',
      createdAt: '2026-04-28T05:57:27.754Z',
      updatedAt: '2026-04-30T07:08:24.927Z',
      publishedAt: '2026-04-30T07:08:25.675Z',
      locale: 'en',
      documentId: 'dcfyg7k5sdyrg2x83pmxd150',
    },
    {
      id: 4259,
      slug: 'best-java-web-scraping-libraries',
      createdAt: '2026-04-28T06:58:19.057Z',
      updatedAt: '2026-06-09T12:23:40.794Z',
      publishedAt: '2026-06-09T12:23:43.152Z',
      locale: 'en',
      documentId: 'gqja9gd0187gsssvbmyes3m3',
    },
    {
      id: 3956,
      slug: 'golang-headless-browser',
      createdAt: '2026-04-29T04:54:24.115Z',
      updatedAt: '2026-04-30T11:42:40.837Z',
      publishedAt: '2026-04-30T11:42:41.619Z',
      locale: 'en',
      documentId: 'cqji47lj4qtl4yee4jt9pdj8',
    },
    {
      id: 3958,
      slug: 'scrapegraph-ai',
      createdAt: '2026-04-29T05:32:32.187Z',
      updatedAt: '2026-04-30T11:43:56.032Z',
      publishedAt: '2026-04-30T11:43:56.675Z',
      locale: 'en',
      documentId: 'tccphrlq5df1b8rvxf3snyyi',
    },
    {
      id: 4074,
      slug: 'python-web-scraping-libraries',
      createdAt: '2026-04-29T06:26:46.609Z',
      updatedAt: '2026-05-13T13:06:55.546Z',
      publishedAt: '2026-05-13T13:06:57.443Z',
      locale: 'en',
      documentId: 'al0mi24ymqwp0bd7bek5eukd',
    },
    {
      id: 4255,
      slug: 'powershell-web-scraping',
      createdAt: '2026-04-28T08:58:06.570Z',
      updatedAt: '2026-06-09T11:59:34.735Z',
      publishedAt: '2026-06-09T11:59:35.781Z',
      locale: 'en',
      documentId: 'ygzdzbgtayba7tmd3gaa4jal',
    },
    {
      id: 3987,
      slug: 'curl-basic-auth',
      createdAt: '2026-05-04T13:26:14.429Z',
      updatedAt: '2026-05-05T08:19:50.613Z',
      publishedAt: '2026-05-05T08:19:51.837Z',
      locale: 'en',
      documentId: 's70bmhibm0m7o7gijxgyw7e7',
    },
    {
      id: 4323,
      slug: '500-internal-server-error',
      createdAt: '2026-05-05T13:14:48.026Z',
      updatedAt: '2026-06-11T08:03:43.913Z',
      publishedAt: '2026-06-11T08:03:44.705Z',
      locale: 'en',
      documentId: 'sl6xe5vogu58oiit7w0zav5i',
    },
    {
      id: 4043,
      slug: 'jquery-web-scraping',
      createdAt: '2026-05-06T13:10:58.741Z',
      updatedAt: '2026-05-07T06:22:02.694Z',
      publishedAt: '2026-05-07T06:22:03.437Z',
      locale: 'en',
      documentId: 'uvz7q6z56ll7bv062e7jjfmn',
    },
    {
      id: 4252,
      slug: 'what-is-mobile-proxy',
      createdAt: '2026-05-07T10:28:00.195Z',
      updatedAt: '2026-06-09T11:42:51.306Z',
      publishedAt: '2026-06-09T11:42:52.362Z',
      locale: 'en',
      documentId: 'yoz44ix0p66gayj6ecwm4ukb',
    },
    {
      id: 4048,
      slug: 'puppeteer-vs-selenium',
      createdAt: '2026-05-07T12:18:15.048Z',
      updatedAt: '2026-05-07T13:03:16.843Z',
      publishedAt: '2026-05-07T13:03:17.967Z',
      locale: 'en',
      documentId: 'ke8n5aag5ah0dv9ihzci34kd',
    },
    {
      id: 4062,
      slug: 'json-parse-javascript',
      createdAt: '2026-05-12T07:49:37.587Z',
      updatedAt: '2026-05-12T10:01:53.958Z',
      publishedAt: '2026-05-12T10:01:55.811Z',
      locale: 'en',
      documentId: 'qdfg38befqwtuqrnqveziha5',
    },
    {
      id: 4065,
      slug: 'cart-abandonment-discount-timing',
      createdAt: '2026-05-12T13:14:40.002Z',
      updatedAt: '2026-05-13T06:07:06.121Z',
      publishedAt: '2026-05-13T06:07:06.836Z',
      locale: 'en',
      documentId: 'bwnrve3bmtaj1cq20jvd1rom',
    },
    {
      id: 4068,
      slug: 'playwright-xpath',
      createdAt: '2026-05-13T05:54:02.698Z',
      updatedAt: '2026-05-13T07:34:58.697Z',
      publishedAt: '2026-05-13T07:34:59.559Z',
      locale: 'en',
      documentId: 'icsclp46dybc3klp731mgmbh',
    },
    {
      id: 4079,
      slug: 'memorial-day-sales-2026',
      createdAt: '2026-05-13T12:39:14.926Z',
      updatedAt: '2026-05-14T11:41:58.311Z',
      publishedAt: '2026-05-14T11:42:00.953Z',
      locale: 'en',
      documentId: 'zm6e7o91ww89ke9xjzjp1ind',
    },
    {
      id: 4092,
      slug: 'xpath-using-text',
      createdAt: '2026-05-15T06:21:12.817Z',
      updatedAt: '2026-05-18T10:14:11.888Z',
      publishedAt: '2026-05-18T10:14:13.570Z',
      locale: 'en',
      documentId: 'thk7voaj5gblspjcdbe6dvp1',
    },
    {
      id: 4286,
      slug: 'asynchronous-web-scraping-python',
      createdAt: '2026-05-18T08:12:16.518Z',
      updatedAt: '2026-06-10T07:40:20.729Z',
      publishedAt: '2026-06-10T07:40:22.077Z',
      locale: 'en',
      documentId: 'xxvtc4pstqll1lgwsu9919uf',
    },
    {
      id: 4107,
      slug: 'elixir-web-scraping',
      createdAt: '2026-05-19T06:22:04.667Z',
      updatedAt: '2026-05-19T07:40:43.734Z',
      publishedAt: '2026-05-19T07:40:44.948Z',
      locale: 'en',
      documentId: 'moc5fpc5hks8zgnqdxvhdh37',
    },
    {
      id: 4168,
      slug: 'end-of-free-public-data',
      createdAt: '2026-05-19T09:11:37.089Z',
      updatedAt: '2026-05-26T11:01:01.946Z',
      publishedAt: '2026-05-26T11:01:02.842Z',
      locale: 'en',
      documentId: 'fuw0nmoxp5nd490l49wkfrkw',
    },
    {
      id: 4322,
      slug: 'curl-send-json',
      createdAt: '2026-05-19T13:19:06.325Z',
      updatedAt: '2026-06-11T08:01:54.518Z',
      publishedAt: '2026-06-11T08:01:56.114Z',
      locale: 'en',
      documentId: 'ckw90x809tonw2cwlg9kt2vr',
    },
    {
      id: 4119,
      slug: 'what-is-charles-proxy',
      createdAt: '2026-05-20T12:31:07.932Z',
      updatedAt: '2026-05-20T13:28:40.745Z',
      publishedAt: '2026-05-20T13:28:41.315Z',
      locale: 'en',
      documentId: 'grxipsseyz15x8x5zh4sdehs',
    },
    {
      id: 4128,
      slug: 'smartproxy-org-impersonator-ipidea-overlap',
      createdAt: '2026-05-19T12:32:44.175Z',
      updatedAt: '2026-05-22T07:59:54.038Z',
      publishedAt: '2026-05-22T07:59:55.094Z',
      locale: 'en',
      documentId: 'dsig6bcvblehgh8pbpc6lewg',
    },
    {
      id: 4130,
      slug: 'urllib3-vs-requests',
      createdAt: '2026-05-22T10:59:40.587Z',
      updatedAt: '2026-05-22T12:34:39.788Z',
      publishedAt: '2026-05-22T12:34:40.687Z',
      locale: 'en',
      documentId: 's5rxxxts60fq7ke1mi4zg0cl',
    },
    {
      id: 4133,
      slug: 'how-to-select-elements-by-class-xpath',
      createdAt: '2026-05-25T06:13:26.543Z',
      updatedAt: '2026-05-25T07:16:26.872Z',
      publishedAt: '2026-05-25T07:16:27.728Z',
      locale: 'en',
      documentId: 'wawnpwm4ra0q9479q0abdgmz',
    },
    {
      id: 4145,
      slug: 'cursor-ai-web-scraper',
      createdAt: '2026-05-25T12:29:54.667Z',
      updatedAt: '2026-05-25T13:16:14.430Z',
      publishedAt: '2026-05-25T13:16:15.208Z',
      locale: 'en',
      documentId: 'tedhv1o9mv1hijwo539mox7f',
    },
    {
      id: 4151,
      slug: 'scrape-imdb',
      createdAt: '2026-05-26T06:34:38.456Z',
      updatedAt: '2026-05-26T09:27:07.772Z',
      publishedAt: '2026-05-26T09:27:10.175Z',
      locale: 'en',
      documentId: 'bb2foh4s30gcd27wib46hzz5',
    },
    {
      id: 4273,
      slug: 'node-fetch-proxy',
      createdAt: '2026-05-26T10:27:35.571Z',
      updatedAt: '2026-06-09T13:31:41.305Z',
      publishedAt: '2026-06-09T13:31:42.652Z',
      locale: 'en',
      documentId: 'dl3otvl3y83kkefbf9gu0uo6',
    },
    {
      id: 4352,
      slug: 'python-try-except',
      createdAt: '2026-05-26T12:12:32.089Z',
      updatedAt: '2026-06-15T12:27:30.094Z',
      publishedAt: '2026-06-15T12:27:31.235Z',
      locale: 'en',
      documentId: 't8c3jsb8waot6p299o8yc28a',
    },
    {
      id: 4174,
      slug: 'web-scraping-in-dify',
      createdAt: '2026-05-26T12:41:01.948Z',
      updatedAt: '2026-05-27T06:23:35.673Z',
      publishedAt: '2026-05-27T06:23:36.492Z',
      locale: 'en',
      documentId: 'ximp8q733gnqbigd4vy0lv36',
    },
    {
      id: 4177,
      slug: 'api-vs-web-scraping',
      createdAt: '2026-05-27T11:15:17.446Z',
      updatedAt: '2026-05-27T11:54:45.437Z',
      publishedAt: '2026-05-27T11:54:46.125Z',
      locale: 'en',
      documentId: 'a1cimdvxx4molbvl7rgto4pn',
    },
    {
      id: 4179,
      slug: 'open-webui-tools-web-access',
      createdAt: '2026-05-28T05:25:14.084Z',
      updatedAt: '2026-05-28T06:44:36.785Z',
      publishedAt: '2026-05-28T06:44:37.571Z',
      locale: 'en',
      documentId: 'qujr8zcopcpte1l15gly8tvm',
    },
    {
      id: 4182,
      slug: 'python-extract-text-from-html',
      createdAt: '2026-05-28T09:22:59.235Z',
      updatedAt: '2026-05-28T10:39:00.783Z',
      publishedAt: '2026-05-28T10:39:01.378Z',
      locale: 'en',
      documentId: 'jv8c6smudt5o8x7hwcmp9ib5',
    },
    {
      id: 4184,
      slug: 'puppeteer-infinite-scroll',
      createdAt: '2026-05-28T12:16:35.348Z',
      updatedAt: '2026-05-28T13:05:37.643Z',
      publishedAt: '2026-05-28T13:05:38.480Z',
      locale: 'en',
      documentId: 'nqgsb8m1anhchiq2wlp2hg14',
    },
    {
      id: 4187,
      slug: 'how-to-build-a-rank-tracker',
      createdAt: '2026-05-28T06:46:08.981Z',
      updatedAt: '2026-06-01T06:36:57.992Z',
      publishedAt: '2026-06-01T06:37:00.059Z',
      locale: 'en',
      documentId: 'r976wqcsztky92rpwi9tn2nb',
    },
    {
      id: 4190,
      slug: 'how-to-bypass-cloudflare',
      createdAt: '2026-06-01T13:20:33.333Z',
      updatedAt: '2026-06-02T06:04:51.182Z',
      publishedAt: '2026-06-02T06:04:51.917Z',
      locale: 'en',
      documentId: 'gcjif91rss75r4n5ya4c4wti',
    },
    {
      id: 4192,
      slug: 'switch-google-to-duckduckgo',
      createdAt: '2026-06-02T06:16:28.126Z',
      updatedAt: '2026-06-02T06:54:28.762Z',
      publishedAt: '2026-06-02T06:54:29.492Z',
      locale: 'en',
      documentId: 'vrm21lfknl1u9rktrdq8urtk',
    },
    {
      id: 4247,
      slug: 'news-crawler',
      createdAt: '2026-06-02T13:27:49.525Z',
      updatedAt: '2026-06-09T10:34:27.398Z',
      publishedAt: '2026-06-09T10:34:28.153Z',
      locale: 'en',
      documentId: 'p7i81xdihgcptumvnadut5e0',
    },
    {
      id: 4216,
      slug: 'mechanicalsoup-python',
      createdAt: '2026-06-03T11:04:22.932Z',
      updatedAt: '2026-06-05T08:05:33.311Z',
      publishedAt: '2026-06-05T08:05:35.199Z',
      locale: 'en',
      documentId: 'q7ehoccftzjbbuoiul6yiftn',
    },
    {
      id: 4208,
      slug: 'cpp-web-scraping',
      createdAt: '2026-06-04T06:02:17.703Z',
      updatedAt: '2026-06-04T06:24:25.969Z',
      publishedAt: '2026-06-04T06:24:26.760Z',
      locale: 'en',
      documentId: 'v1unhlos5tksfnwlgwhenyru',
    },
    {
      id: 4209,
      slug: 'odysseus-pewdiepie',
      createdAt: '2026-06-04T03:40:00.733Z',
      updatedAt: '2026-06-04T07:57:46.775Z',
      publishedAt: '2026-06-04T07:57:47.630Z',
      locale: 'en',
      documentId: 'rew9l0drkw0xws3pxyvk8mzh',
    },
    {
      id: 4245,
      slug: 'puppeteer-submit-form',
      createdAt: '2026-06-03T11:35:10.404Z',
      updatedAt: '2026-06-09T10:09:40.090Z',
      publishedAt: '2026-06-09T10:09:41.057Z',
      locale: 'en',
      documentId: 'd1srn70yvx0leovqpmwmj9vg',
    },
    {
      id: 4237,
      slug: 'price-scraping',
      createdAt: '2026-05-27T10:03:08.162Z',
      updatedAt: '2026-06-08T06:01:04.959Z',
      publishedAt: '2026-06-08T06:01:05.909Z',
      locale: 'en',
      documentId: 'v3wnuskmxw0godc37toeha5l',
    },
    {
      id: 4240,
      slug: 'puppeteer-download-file',
      createdAt: '2026-06-08T09:51:56.561Z',
      updatedAt: '2026-06-08T11:05:36.208Z',
      publishedAt: '2026-06-08T11:05:38.152Z',
      locale: 'en',
      documentId: 's72f2mgph5rihhjwkann6ley',
    },
    {
      id: 4244,
      slug: 'vibe-scraping',
      createdAt: '2026-06-09T06:25:53.692Z',
      updatedAt: '2026-06-09T07:16:31.682Z',
      publishedAt: '2026-06-09T07:16:32.374Z',
      locale: 'en',
      documentId: 't98m6ii1r34sbnravbe5thh9',
    },
    {
      id: 4287,
      slug: 'golang-colly',
      createdAt: '2026-06-10T05:21:01.692Z',
      updatedAt: '2026-06-10T10:13:02.564Z',
      publishedAt: '2026-06-10T10:13:03.860Z',
      locale: 'en',
      documentId: 'bz0ba0992qciqja35yvwt7vs',
    },
    {
      id: 4288,
      slug: 'no-code-web-scraping-n8n',
      createdAt: '2026-06-10T05:55:53.888Z',
      updatedAt: '2026-06-10T10:13:39.090Z',
      publishedAt: '2026-06-10T10:13:40.200Z',
      locale: 'en',
      documentId: 'u0khv7mmtl71syi9tmn7gdnh',
    },
    {
      id: 4301,
      slug: 'claude-fable-5-web-scraping',
      createdAt: '2026-06-10T10:31:53.706Z',
      updatedAt: '2026-06-10T11:43:33.441Z',
      publishedAt: '2026-06-10T11:43:34.669Z',
      locale: 'en',
      documentId: 'matprjra2rmwvs539hyhy7ak',
    },
    {
      id: 4302,
      slug: 'groovy-web-scraping',
      createdAt: '2026-06-10T11:27:07.662Z',
      updatedAt: '2026-06-10T12:51:00.089Z',
      publishedAt: '2026-06-10T12:51:00.960Z',
      locale: 'en',
      documentId: 'wvrrppfbgj0xag60wu4czmwo',
    },
    {
      id: 4335,
      slug: 'watir-ruby-web-scraping',
      createdAt: '2026-06-11T08:14:40.496Z',
      updatedAt: '2026-06-11T11:47:52.261Z',
      publishedAt: '2026-06-11T11:47:53.477Z',
      locale: 'en',
      documentId: 'dlpr03ea1j30om7zw2z31574',
    },
    {
      id: 4339,
      slug: 'web-scraping-with-node-fetch',
      createdAt: '2026-06-11T11:58:06.936Z',
      updatedAt: '2026-06-11T13:17:49.292Z',
      publishedAt: '2026-06-11T13:17:49.915Z',
      locale: 'en',
      documentId: 'mij0ghdmnvb220jk3zj7ym35',
    },
    {
      id: 4341,
      slug: 'hermes-agent-vs-openclaw',
      createdAt: '2026-06-12T10:42:48.970Z',
      updatedAt: '2026-06-12T11:22:42.552Z',
      publishedAt: '2026-06-12T11:22:43.254Z',
      locale: 'en',
      documentId: 'zij5twufqq0r3imr3l0714rh',
    },
    {
      id: 4346,
      slug: 'scala-web-scraping',
      createdAt: '2026-06-12T12:05:21.723Z',
      updatedAt: '2026-06-12T13:13:57.201Z',
      publishedAt: '2026-06-12T13:13:58.508Z',
      locale: 'en',
      documentId: 'lvu68kmchn6xztkgn6vqz5wn',
    },
    {
      id: 4348,
      slug: 'puppeteer-proxy',
      createdAt: '2026-06-15T06:07:05.242Z',
      updatedAt: '2026-06-15T06:56:01.890Z',
      publishedAt: '2026-06-15T06:56:03.122Z',
      locale: 'en',
      documentId: 'aqd2gebs5a81msufumjnihrs',
    },
    {
      id: 4350,
      slug: 'parse-html-with-regex',
      createdAt: '2026-06-15T11:32:09.800Z',
      updatedAt: '2026-06-15T12:02:02.352Z',
      publishedAt: '2026-06-15T12:02:03.066Z',
      locale: 'en',
      documentId: 'qo98zru4iuo8rmpkqlcdy4n0',
    },
    {
      id: 4356,
      slug: 'kotlin-web-scraping',
      createdAt: '2026-06-15T12:54:08.834Z',
      updatedAt: '2026-06-16T06:00:56.593Z',
      publishedAt: '2026-06-16T06:00:57.658Z',
      locale: 'en',
      documentId: 'xru2j9xh0y2qywsuax48xjjm',
    },
    {
      id: 4371,
      slug: 'block-requests-puppeteer',
      createdAt: '2026-06-16T08:06:42.440Z',
      updatedAt: '2026-06-16T09:34:11.393Z',
      publishedAt: '2026-06-16T09:34:12.536Z',
      locale: 'en',
      documentId: 'bcno4qzi7n6inx8yo0fr3kkl',
    },
    {
      id: 4378,
      slug: 'crawlee-python',
      createdAt: '2026-06-16T12:12:06.937Z',
      updatedAt: '2026-06-16T13:10:06.461Z',
      publishedAt: '2026-06-16T13:10:07.450Z',
      locale: 'en',
      documentId: 'q9iq2j0cs84ugs217n4z2zql',
    },
    {
      id: 4379,
      slug: 'python-cloudscraper',
      createdAt: '2026-06-16T09:53:14.846Z',
      updatedAt: '2026-06-16T13:10:10.809Z',
      publishedAt: '2026-06-16T13:10:11.877Z',
      locale: 'en',
      documentId: 'kevlihi542c52d5kcnf96nj0',
    },
    {
      id: 4384,
      slug: 'rank-tracker-getting-blocked',
      createdAt: '2026-06-17T05:22:28.054Z',
      updatedAt: '2026-06-17T06:36:44.982Z',
      publishedAt: '2026-06-17T06:36:47.718Z',
      locale: 'en',
      documentId: 'w4w1jjkxzl0hxt44v0qg0tf4',
    },
  ],
  localizations: [],
};
